/* eslint-disable no-multiple-empty-lines */
/* eslint-disable no-trailing-spaces */
/* eslint-disable no-useless-computed-key */
export default {
	['较大']: 'बड़ा करें',
	['预设']: 'डिफ़ॉल्ट',
	['较小']: 'छोटा करें',
	['字级大小']: 'फ़ॉन्ट का आकार',
	['页面正在加载中']: 'पृष्ठ लोड हो रहा है',
	['这可能需要几分钟的时间，请耐心等待']: 'इसमें कुछ मिनट लग सकते हैं, कृपया धैर्य रखें',
	['您所访问的页面不存在']: 'वह पृष्ठ उपलब्ध नहीं है',
	['开始对话']: 'वार्तालाप शुरू करें',
	['充值未到帐快速通道']: 'रीचार्ज न मिलने पर त्वरित सहायता',
	['人工客服']: 'कृत्रिम ग्राहक सेवा',
	['已接听']: 'कॉल रिसीव हो चुका है',
	['结束对话']: 'वार्तालाप समाप्त करें',
	['联络人工客服']: 'सपोर्ट एजेंट से संपर्क करें',
	['重新选择智能客服']: 'स्मार्ट कस्टमर सर्विस को पुनः चुनें',
	['感谢您使用本次服务，烦请拨冗补充填写调查，您宝贵的意见是我们前进的动力！']: 'सेवा का उपयोग करने के लिए आपका धन्यवाद। कृपया सर्वेक्षण भरने के लिए थोड़ा समय निकालें। आपका मूल्यवान सुझाव हमारे लिए प्रेरणा है।',
	['您觉得此次的服务品质如何？']: 'आपको इस बार की सेवा की गुणवत्ता कैसी लगी？',
	['颗星']: 'स्टार',
	['颗星(單數)']: 'स्टार',
	['不评分']: 'नहीं रेटिंग',
	['点选下方即可结束对话']: 'नीचे चयन करके आप वार्तालाप समाप्त कर सकते हैं',
	['请输入您的ID']: 'कृपया अपना ID दर्ज करें',
	['ID不能为空']: 'ID अनिवार्य है।',
	['说明文字']: 'स्पष्टीकरण पाठ',
	['送出']: 'जमा करें',
	['系统维护中']: 'सिस्टम रखरखाव चल रहा है',
	['储存']: 'सहेजें',
	['确认']: 'पुष्टि करें',
	['取消']: 'रद्द करें',
	['完成']: 'पूरा करना',
	['协作']: 'सहयोग',
	['转接']: 'ट्रांसफर',
	['离开']: 'बाहर निकलें',
	['请选择服务对象开始通话']: 'कॉल शुरू करने के लिए कृपया सेवा प्राप्तकर्ता का चयन करें',
	['请填写表单']: 'कृपया फॉर्म भरें',
	['本对话已经结束']: 'यह वार्ता समाप्त हो चुकी है',
	['客服已逾 {{second}} 秒未回应']: 'ग्राहक सेवा ने {{second}} सेकंड से अधिक समय तक प्रतिक्रिया नहीं दी है',
	['历史对话']: 'इतिहास संवाद',
	['查无资料']: 'कोई जानकारी नहीं मिली',
	['标签']: 'लेबल',
	['正在输入中...']: 'आ रहा है...',
	['于']: 'में',
	['档案容量限制']: 'फाइल आकार सीमा',
	['不能为空']: 'खाली नहीं होना चाहिए',
	['提交']: 'जमा करें',
	['满意度']: 'संतोषजनकता',
	['IP未知']: 'IP अज्ञात',
	['地区未知']: 'क्षेत्र अज्ञात',
	['使用者环境未知']: 'उपयोगकर्ता वातावरण अज्ञात',
	['关闭']: 'बंद करें',
	['全萤幕截图成档案']: 'फुल स्क्रीन का स्क्रीनशॉट फ़ाइल के रूप में सहेजें',
	['Mac用户']: 'Mac उपयोगकर्ता',
	['Windows用户']: 'Windows उपयोगकर्ता',
	['Windows键']: 'Windows की',
	['全萤幕截图至剪贴簿']: 'फुल स्क्रीन का स्क्रीनशॉट क्लिपबोर्ड पर कॉपी करें',
	['截图完成后请直接于文字输入处贴上']: 'स्क्रीनशॉट लेने के बाद, कृपया इसे सीधे टेक्स्ट बॉक्स में पेस्ट करें।',
	['使用Windows内建截图工具或者QQ软件截图功能，截图完成后请直接于文字输入处贴上']: 'Windows के इनबिल्ट स्क्रीनशॉट टूल या QQ सॉफ्टवेयर का उपयोग करें। स्क्रीनशॉट लेने के बाद, कृपया इसे सीधे टेक्स्ट इनपुट बॉक्स में पेस्ट करें।',
	['截图']: 'स्क्रीनशॉट',
	['档案']: 'फ़ाइल',
	['下载失败']: 'डाउनलोड विफल',
	['请输入分类名称']: 'कृपया वर्ग का नाम दर्ज करें',
	['新增']: 'नया जोड़ें',
	['更新']: 'अद्यतन',
	['请选择一个分类']: 'कृपया एक श्रेणी चुनें',
	['请输入标题']: 'कृपया शीर्षक दर्ज करें',
	['请输入内文']: 'कृपया अंतर्बोध करें',
	['请上传图片']: 'कृपया चित्र अपलोड करें',
	['快捷语']: 'तत्कालीन भाषा',
	['图片']: 'चित्र',
	['管理分类']: 'प्रबंधन वर्गीकरण',
	['新增分类']: 'नई श्रेणी जोड़ें',
	['标题/内文']: 'शीर्षक/मुख्य सामग्री',
	['分类']: 'श्रेणी',
	['编辑']: 'सम्पादित',
	['删除']: 'हटाना',
	['平台名称']: 'प्लेटफॉर्म का नाम',
	['显示']: 'दिखाना',
	['编辑服务平台']: 'संपादित सेवा मंच',
	['若有服务中的客户，无法关闭服务平台']: 'यदि सेवा में ग्राहक हैं, तो सेवा प्लेटफ़ॉर्म बंद नहीं किया जा सकता।',
	['确定']: 'ठीक है',
	['人员列表']: 'कर्मचारी सूची',
	['服务人数']: 'सेवा संख्या',
	['选择转接人员']: 'चुनें स्थानांतरित करने वाले व्यक्ति',
	['按此上传图片']: 'यहाँ क्लिक करके तस्वीर अपलोड करें',
	['确定要取消{{displayName}}协作邀请吗？']: 'क्या आप वास्तव में {{displayName}} के सहयोग निमंत्रण को रद्द करना चाहते हैं?',
	['确定要结束{{displayName}}的协作吗？']: 'क्या आप निश्चित रूप से {{displayName}} का सहयोग समाप्त करना चाहते हैं?',
	['等待协作中']: 'सहयोग की प्रतीक्षा में',
	['协作中']: 'सहयोग में',
	['负责人']: 'ज़िम्मेदार',
	['已选择']: 'चुना गया',
	['可协作人数已满']: 'सहयोगी संख्या पूरी हो चुकी है',
	['选择协作人员']: 'सहयोगी का चयन करें',
	['提示']: 'सुझाव',
	['请输入讯息']: 'कृपया संदेश दर्ज करें',
	['确定已經完成？']: 'क्या यह सुनिश्चित है कि यह पूरा हो गया है?',
	['常用图片']: 'आम चित्र',
	['用户']: 'उपयोगकर्ता',
	['个人']: 'व्यक्ति',
	['公共']: 'सार्वजनिक',
	['开始谈话']: 'बातचीत शुरू करें',
	['等待中']: 'प्रतीक्षा में',
	['客户已离开对话']: 'ग्राहक संवाद छोड़ चुका है',
	['正在转接给']: 'संक्रमण कर रहा है',
	['邀请你加入协作']: 'आपको सहयोग में शामिल होने के लिए आमंत्रित किया जाता है।',
	['请求转接']: 'अनुरोध अग्रेषित करें',
	['正在服务中']: 'सेवा में है',
	['编辑平台']: 'संपादन प्लेटफ़ॉर्म',
	['您的连线已中断']: 'आपका कनेक्शन टूट गया है',
	['正尝试重新连线']: 'सचमुच फिर से कनेक्ट करने की कोशिश कर रहा है',
	['重新登入']: 'फिर से लॉगिन करें',
	['请先登入']: 'कृपया पहले लॉगिन करें',
	['帐号']: 'खाता',
	['帐号不能为空']: 'खाता खाली नहीं हो सकता',
	['请输入帐号']: 'कृपया खाता दर्ज करें',
	['密码']: 'पासवर्ड',
	['密码不能为空']: 'पासवर्ड खाली नहीं होना चाहिए',
	['请输入密码']: 'कृपया पासवर्ड दर्ज करें',
	['登录']: 'लॉगिन',
	['客服系统客服端']: 'ग्राहक सेवा प्रणाली ग्राहक पक्ष',
	['平台异动，请重新整理']: 'प्लेटफ़ॉर्म में परिवर्तन, कृपया पुनः लोड करें',
	['客服系统升级维护中，请您晚点再联系线上客服，谢谢']: 'कस्टमर सर्विस सिस्टम अपग्रेड और मेंटेनेंस में है, कृपया आप थोड़ी देर बाद ऑनलाइन कस्टमर सर्विस से संपर्क करें, धन्यवाद।',
	['客服系统进入升级维护作业，很抱歉中断您的对话，请您晚点再联系线上客服']: 'ग्राहक सेवा प्रणाली उन्नयन रखरखाव कार्य में प्रवेश कर रही है, आपके संवाद में विघटन के लिए खेद है, कृपया आप थोड़ी देर बाद ऑनलाइन ग्राहक सेवा से संपर्क करें।',
	['请稍后再试']: 'कृपया बाद में पुन: प्रयास करें',
	['是']: 'है',
	['否']: 'नहीं',
	['等于']: 'बराबर',
	['包含']: 'शामिल',
	['排除']: 'बहिष्कृत',
	['大于']: 'बड़ा',
	['少于']: 'कम',
	['数量区间']: 'संख्यान्तर',
	['客服对话数']: 'ग्राहक सेवा संवाद संख्या',
	['客戶对话数']: 'ग्राहक संवाद संख्या',
	['即时资讯']: 'ताज़ा ख़बरें',
	['报表分析']: 'रिपोर्ट विश्लेषण',
	['平均通话时间']: 'औसत कॉल समय',
	['回覆通话数']: 'उत्तर कॉल संख्या',
	['平均等待时间']: 'सामान्य प्रतीक्षा समय',
	['客户满意度']: 'ग्राहक संतोष',
	['历史对话记录']: 'इतिहास संवाद रिकॉर्ड',
	['操作日志']: 'कार्रवाई लॉग',
	['智能客服设定']: 'स्मार्ट ग्राहक सेवा सेटिंग',
	['机器人设定']: 'रोबोट सेटिंग',
	['版本管理']: 'संस्करण प्रबंधन',
	['档案总览']: 'फ़ाइल अवलोकन',
	['设定']: 'सेटिंग',
	['公司管理']: 'कंपनी प्रबंधन',
	['维修管理']: 'मरम्मत प्रबंधन',
	['一般设定']: 'सामान्य सेटिंग',
	['公告管理']: 'सूचना प्रबंधन',
	['帐号管理']: 'खाता प्रबंधन',
	['平台管理']: 'प्लेटफ़ॉर्म प्रबंधन',
	['角色管理']: 'भूमिका प्रबंधन',
	['团队管理']: 'टीम प्रबंधन',
	['标签管理']: 'लेबल प्रबंधन',
	['查询']: 'संदेश',
	['重置']: 'रीसेट',
	['今天']: 'आज',
	['昨天']: 'कल',
	['过去7天']: 'पिछले 7 दिन',
	['过去10天']: 'पिछले 10 दिन',
	['过去一个月']: 'पिछला एक महीना',
	['过去90天']: 'अतीत के 90 दिन',
	['LOGO 预览']: 'LOGO पूर्वावलोकन',
	['档案格式：PNG、JPG，长宽不超过']: 'फ़ाइल फ़ormat: PNG, JPG, लंबाई चौड़ाई अधिकतम',
	['档案太大或格式不支援']: 'फाइल बहुत बड़ी है या प्रारूप समर्थित नहीं है',
	['且档案大小不得大于']: 'और फ़ाइल का आकार  से अधिक नहीं होना चाहिए',
	['上传档案']: 'अपलोड फ़ाइल',
	['新增IP白名单成功']: 'IP श्वेतसूची सफलतापूर्वक जोड़ दी गई',
	['删除IP白名单成功']: 'IP श्वेतसूची हटाना सफल',
	['请输入欲查询的IP']: 'कृपया जांचने के लिए IP दर्ज करें',
	['请输入IP']: 'कृपया IP दर्ज करें',
	['备注']: 'टिप्पणी',
	['备注不能为空']: 'टिप्पणी खाली नहीं हो सकती',
	['请输入备注']: 'कृपया टिप्पणी दर्ज करें',
	['新增时间']: 'नया समय',
	['操作']: 'क्रिया',
	['IP白名单']: 'IP श्वेतसूची',
	['新增IP']: 'नया IP',
	['新增IP白名单']: 'नया आईपी श्वेतसूची जोड़ें',
	['确定删除此IP?']: 'क्या आप इस IP को हटाना निश्चित कर रहे हैं?',
	['平台']: 'प्लेटफ़ॉर्म',
	['团队']: 'टीम',
	['全体']: 'संपूर्ण',
	['客服']: 'ग्राहक सेवा',
	['客服系统']: 'ग्राहक सेवा प्रणाली',
	['个人帐号设定']: 'व्यक्तिगत खाता सेटिंग',
	['最少6码']: 'कम से कम 6 गज',
	['最多20码']: 'अधिकतम 20 गज',
	['不能有空白']: 'खाली स्थान नहीं होना चाहिए',
	['应至少包含1个英文和数字']: 'कम से कम 1 अंग्रेजी और संख्या होना चाहिए',
	['公司名称']: 'कंपनी का नाम',
	['僅能输入英文和数字']: 'केवल अंग्रेजी और संख्या दर्ज कर सकते हैं',
	['应至少包含1个英文']: 'कम से कम 1 अंग्रेजी शामिल होना चाहिए',
	['最少5码']: 'कम से कम 5 गज',
	['IP不能为空']: 'IP खाली नहीं हो सकता',
	['非IP位址']: 'गैर-आईपी पता',
	['最多500个字']: 'अधिकतम 500 शब्द',
	['启用']: 'सक्रिय करें',
	['禁用']: 'निषिद्ध',
	['对话量']: 'संवाद की मात्रा',
	['目前客户数']: 'वर्तमान ग्राहक संख्या',
	['目前客服数']: 'वर्तमान ग्राहक सेवा संख्या',
	['接通对话量']: 'संवाद मात्रा जोड़ें',
	['全部']: 'सबकुछ',
	['最近一天']: 'हाल ही में एक दिन',
	['最近一周']: 'पिछले एक सप्ताह',
	['最近一月']: 'हाल के एक महीने',
	['新增过滤器']: 'नया फ़िल्टर जोड़ें',
	['请输入模組名称']: 'कृपया मॉड्यूल का नाम दर्ज करें',
	['储存过滤模組']: 'स्टोरेज फ़िल्टर मॉड्यूल',
	['读取过滤模組']: 'पढ़ें फ़िल्टर मॉड्यूल',
	['确定要删除模組']: 'क्या आप मॉड्यूल को हटाना चाहते हैं?',
	['分钟']: 'मिनट',
	['接通时间']: 'कनेक्ट समय',
	['通话时间']: 'वार्ता का समय',
	['请选择或输入时间']: 'कृपया समय का चयन करें या दर्ज करें',
	['等待时间']: 'इंतज़ार का समय',
	['对话搜寻']: 'संवाद खोज',
	['请输入对话']: 'कृपया वार्तालाप दर्ज करें',
	['客戶 ID']: 'ग्राहक आईडी',
	['请输入客戶ID']: 'कृपया ग्राहक आईडी डालें',
	['对话浏览模式']: 'संवाद ब्राउज़िंग मोड',
	['筆']: 'कलम',
	['客服本名']: 'ग्राहक सेवा का असली नाम',
	['进入时间']: 'प्रवेश समय',
	['客服昵称']: 'ग्राहक सेवा उपनाम',
	['客服系统管理端']: 'ग्राहक सेवा प्रणाली प्रबंधन पोर्टल',
	['数量']: 'संख्या',
	['尚未上传档案']: 'फाइल अपलोड नहीं हुई है',
	['输入文字']: 'इनपुट टेक्स्ट',
	['请在此输入文字']: 'कृपया यहाँ पाठ दर्ज करें',
	['添加项目']: 'आइटम जोड़ें',
	['请选择']: 'कृपया चुनें',
	['新增文字']: 'नया पाठ जोड़ें',
	['新增档案']: 'नया फ़ाइल जोड़ें',
	['選項']: 'विकल्प',
	['勾选标题']: 'शीर्षक का चयन करें',
	['文字內容不能为空']: 'शब्द सामग्री शून्य नहीं हो सकता',
	['添加']: 'जोड़ना',
	['上传标题']: 'अपलोड शीर्षक',
	['单选标题']: 'एकल चयन शीर्षक',
	['输入框标题']: 'इनपुट फ़ील्ड शीर्षक',
	['请输入']: 'कृपया दर्ज करें',
	['输入框']: 'इनपुट बॉक्स',
	['单选']: 'एकल उत्तर',
	['核取方块']: 'चेक बॉक्स',
	['请选择一个标签']: 'कृपया एक टैग चुनें',
	['确定要删除此项目和其所有子项目？']: 'क्या आप सुनिश्चित हैं कि आप इस आइटम और इसके सभी उप-आइटम को हटाना चाहते हैं?',
	['答案']: 'उत्तर',
	['表单']: 'फॉर्म',
	['清除此阶层设定']: 'इस स्तर की सेटिंग को हटा दें',
	['请输入此阶层问题']: 'कृपया इस स्तर का प्रश्न दर्ज करें',
	['新增选项']: 'नया विकल्प जोड़ें',
	['新增表单']: 'नया फ़ॉर्म जोड़ें',
	['新增答案']: 'नया उत्तर जोड़ें',
	['新增充值表单']: 'नया रिचार्ज फॉर्म जोड़ें',
	['若切换种类后, 将清除原有的和其子项目资料']: 'यदि प्रकार बदलते हैं, तो मौजूदा और उसके उप-आइटम डेटा मिटा दिए जाएंगे।',
	['确定要清除所有资料和其子项目资料？']: 'क्या आप सभी डेटा और इसके उप-निर्देशों के डेटा को साफ़ करने के लिए सुनिश्चित हैं?',
	['阶层']: 'स्तर',
	['开场语']: 'प्रस्तावना',
	['开场语不能为空']: 'आरंभिक वाक्य नहीं हो सकता',
	['结尾感谢语']: 'समापन धन्यवाद शब्द',
	['结尾感谢语不能为空']: 'अंत का धन्यवाद संदेश खाली नहीं हो सकता',
	['发布']: 'प्रकाशित',
	['复制']: 'प्रतिलिपि',
	['选择目的平台']: 'लक्षित मंच चुनें',
	['确定复制到']: 'निश्चित रूप से कॉपी करें',
	['是否要正式发布到使用环境？']: 'क्या इसे उपयोग के वातावरण में आधिकारिक रूप से जारी करना है?',
	['储存版本']: 'संरक्षित संस्करण',
	['版本名称']: 'संस्करण का नाम',
	['请输入版本名称']: 'कृपया संस्करण नाम दर्ज करें',
	['确定是否储存此版本']: 'क्या आप इस संस्करण को सहेजना चाहते हैं?',
	['版本储存成功']: 'संस्करण संग्रहित सफलतापूर्वक',
	['最多10个字']: 'अधिकतम 10 शब्द',
	['公告一']: 'अधिसूचना एक',
	['公告二']: 'सूचना II',
	['公告三']: 'सूचना तीन',
	['公告储存成功']: 'सूचना सफलतापूर्वक संग्रहीत हुई',
	['标题']: 'शीर्षक',
	['內文']: 'आंतरिक सामग्री',
	['修改登入密码']: 'लॉगिन पासवर्ड बदलें',
	['修改基本资讯']: 'बुनियादी जानकारी संशोधित करें',
	['昵称']: 'उपनाम',
	['昵称不能为空']: 'उपनि नाम खाली नहीं हो सकता',
	['请输入昵称']: 'कृपया उपनाम दर्ज करें',
	['本名']: 'वास्तविक नाम',
	['本名不能为空']: 'वास्तविक नाम खाली नहीं हो सकता',
	['请输入本名']: 'आपका असली नाम दर्ज करें',
	['选择图像']: 'चित्र चुनें',
	['状态']: 'स्थिति',
	['平台代码']: 'प्लेटफ़ॉर्म कोड',
	['平台代码不能为空']: 'प्लेटफ़ॉर्म कोड खाली नहीं हो सकता',
	['使用ID模式登入']: 'आईडी मोड का उपयोग करके लॉगिन करें',
	['新增平台']: 'नया प्लेटफ़ॉर्म',
	['修改平台']: 'संशोधित मंच',
	['确定重新产生Key/IV?']: 'क्या आप Key/IV को फिर से उत्पन्न करने की पुष्टि करते हैं?',
	['进入公司成功']: 'कंपनी में सफलता से प्रवेश',
	['确定禁用公司?']: 'क्या कंपनी को अक्षम करना तय है?',
	['确定启用公司?']: 'क्या कंपनी सक्रिय करने की पुष्टि करें?',
	['修改公司']: 'संशोधित कंपनी',
	['进入公司']: 'कंपनी में प्रवेश',
	['确定进入公司?']: 'क्या कंपनी में प्रवेश करना निश्चित है?',
	['新增标签']: 'नया टैग जोड़ें',
	['代号']: 'कोड नाम',
	['代号不可为空']: 'कोड खाली नहीं हो सकता',
	['名称']: 'नाम',
	['名称不可为空']: 'नाम खाली नहीं होना चाहिए',
	['颜色']: 'रंग',
	['颜色不可为空']: 'रंग खाली नहीं हो सकता',
	['进入标签']: 'लेबल में प्रवेश करें',
	['修改标签']: 'संशोधित लेबल',
	['确定开启进入标签?']: 'क्या आप टैब खोलने के लिए सुनिश्चित हैं?',
	['确定关闭进入标签?']: 'क्या आप टैब बंद करने की पुष्टि करते हैं?',
	['确定删除此标签?']: 'क्या आप इस टैग को हटाना सुनिश्चित करते हैं?',
	['标签创建成功']: 'टैग सफलतापूर्वक बनाया गया',
	['标签更新成功']: 'लेबल अपडेट सफलतापूर्वक',
	['进入标签更新成功']: 'टैग में प्रवेश सफलतापूर्वक अपडेट किया गया',
	['标签删除成功']: 'टैग सफलतापूर्वक हटाया गया',
	['请输入代号、名称等关键字']: 'कृपया कोड, नाम आदि कुंजीशब्द दर्ज करें',
	['设定开场白成功']: 'प्रस्तावना सफलतापूर्वक सेट करें',
	['客戶进入开场白']: 'ग्राहक उद्घाटन वाक्य में प्रवेश करता है',
	['客戶进入开场白不可为空']: 'ग्राहक का उद्घाटन भाषण खाली नहीं हो सकता',
	['第一次通知时间']: 'पहली सूचना का समय',
	['第{{count}}次通知时间']: 'दफ़ा {{count}} की सूचना का समय',
	['设置错误']: 'सेटिंग्स में त्रुटि',
	['设定等待过长通知时间成功']: 'अधिकतम प्रतीक्षा समय सफलतापूर्वक सेट करें',
	['秒']: 'सेकंड',
	['对话自动断开时间']: 'संवाद स्वचालित रूप से समाप्त होने का समय',
	['未发话时间']: 'अवाज न देने का समय',
	['未发话提示文字']: 'बात करने का संकेत पाठ',
	['设定对话断开成功']: 'वार्तालाप डिस्कनेक्ट सेटिंग सफल',
	['Favicon预览']: 'फेविकॉन पूर्वावलोकन',
	['更换 Favicon 成功']: 'Favicon बदलने में सफलता मिली',
	['档案格式：ICO，長寬不超過 32x32 px']: 'फाइल फॉर्मेट: ICO, लंबाई चौड़ाई 32x32 px से अधिक नहीं',
	['更换 LOGO 成功']: 'LOGO बदलने में सफलता मिली',
	['智能客服']: 'स्मार्ट कस्टमर सर्विस',
	['设定通道成功']: 'चैनल सेटिंग सफल',
	['设定提示音效成功']: 'ध्वनि चेतावनी सेट करना सफल',
	['单音']: 'एकल ध्वनि',
	['循环音']: 'सर्कुलर साउंड',
	['编号']: 'संख्या',
	['资料类型']: 'संपर्क प्रकार',
	['资料类型不可为空']: 'डेटा प्रकार खाली नहीं हो सकता',
	['数字']: 'संख्या',
	['字串']: 'शृंखला',
	['布林']: 'बिलिन',
	['建立标签成功']: 'लेबल सफलतापूर्वक बनाया गया',
	['修改标签成功']: 'लेबल सफलतापूर्वक संशोधित किया गया',
	['删除标签成功']: 'लेबल हटा दिया जाता है',
	['更换 LOGO']: 'LOGO बदलें',
	['更换 Favicon']: 'फेविकॉन बदलें',
	['对话断开']: 'संवाद बंद',
	['等待过长通知时间']: 'अधिक समय तक अधिसूचना की प्रतीक्षा करें',
	['开场白']: 'प्रस्तावना',
	['提示音效设定']: 'संकेत ध्वनि सेटिंग',
	['通道设定']: 'गेट सेटिंग्स',
	['自定义标签']: 'अनुकूलित लेबल',
	['开启维修模式将会停止客服系统运作。确定要开启嗎？']: 'मरम्मत मोड चालू करने से ग्राहक सेवा प्रणाली का संचालन बंद हो जाएगा। क्या आप वास्तव में चालू करना चाहते हैं?',
	['关闭维修模式，客服系统将会继续运作。确定要关闭嗎？']: 'मरम्मत मोड बंद करें, ग्राहक सेवा प्रणाली कार्य करती रहेगी। क्या आप सच में बंद करना चाहते हैं?',
	['状态更新成功']: 'स्थिति अद्यतन सफल',
	['通知讯息更新成功']: 'सूचना संदेश अपडेट सफल',
	['维修模式']: 'मरम्मत मोड',
	['通知讯息设定']: 'सूचना संदेश सेटिंग',
	['尚未连线状态']: 'अभी तक कनेक्ट नहीं हुआ',
	['尚未连线状态描述']: 'अभी तक कनेक्शन स्थिति विवरण',
	['已连线状态']: 'जिसमें कनेक्टेड स्थिति',
	['已连线状态描述']: 'जुड़ी हुई स्थिति का वर्णन',
	['开启成功']: 'सफलता को प्रारम्भ करें',
	['关闭成功']: 'सफलता से बंद',
	['关闭登入管理模式将会限制客戶藉由输入ID 进入客服，确定要关闭嗎？(若沒有提供客戶Profile资料则会进入错误页面)']: 'लॉगिन प्रबंधन मोड बंद करने से ग्राहकों को आईडी दर्ज करके ग्राहक सेवा में प्रवेश करने में सीमित किया जाएगा, क्या आप बंद करना चाहते हैं? (यदि ग्राहक प्रोफ़ाइल जानकारी प्रदान नहीं की जाती है तो यह त्रुटि पृष्ठ पर जाएगा)',
	['开启登入管理模式将会開放客戶藉由输入 ID 进入客服，确定要开启嗎？']: 'लॉगिन प्रबंधन मोड सक्षम करने से ग्राहक आईडी दर्ज करके ग्राहक सेवा में प्रवेश कर सकेंगे, क्या आप निश्चित हैं कि आप इसे सक्षम करना चाहते हैं?',
	['请输入帐号、昵称、角色等关键字']: 'कृपया खाता, उपनाम, भूमिका आदि कीवर्ड दर्ज करें',
	['新增角色']: 'नया पात्र',
	['修改角色']: 'पात्र को संपादित करें',
	['角色创建成功']: 'चरित्र बनाने में सफलता मिली',
	['角色更新成功']: 'पात्र अपडेट सफल',
	['角色删除成功']: 'भूमिका सफलतापूर्वक हटाई गई',
	['请输入角色名称，平台，权限等关键字']: 'कृपया चरित्र का नाम, प्लेटफ़ॉर्म, अनुमतियाँ आदि कीवर्ड दर्ज करें',
	['关键字']: 'कीवर्ड',
	['角色名称']: 'चरित्र नाम',
	['角色名称不可为空']: 'पात्र का नाम खाली नहीं हो सकता',
	['请输入角色名称']: 'किरदार का नाम दर्ज करें',
	['上级角色']: 'उच्च स्तर की भूमिका',
	['上级角色不可为空']: 'उच्च स्तरीय भूमिका खाली नहीं हो सकती',
	['权限']: 'अधिकार',
	['确定删除此角色?']: 'क्या आप इस चरित्र को हटाने के लिए निश्चित हैं?',
	['图像不能为空']: 'छवि खाली नहीं हो सकती',
	['新增团队']: 'नई टीम',
	['修改团队']: 'संशोधन टीम',
	['团队创建成功']: 'टीम सफलतापूर्वक बन गई',
	['团队修改成功']: 'टीम संशोधन सफल',
	['团队删除成功']: 'टीम को सफलतापूर्वक हटा दिया गया',
	['人数']: 'संख्या',
	['新登入密码']: 'नया प्रवेश पासवर्ड',
	['新密码不能设定與舊密码相同']: 'नया पासवर्ड पुरानी पासवर्ड के समान नहीं हो सकता',
	['新密码與確認密码不相同']: 'नया पासवर्ड और पुष्टि पासवर्ड भिन्न हैं',
	['确定修改登入密码?']: 'क्या आप लॉगिन पासवर्ड संशोधित करना सुनिश्चित करते हैं?',
	['登入密码修改成功，请重新登入']: 'लॉगिन पासवर्ड सफलतापूर्वक बदल दिया गया है, कृपया फिर से लॉगिन करें।',
	['个人资讯']: 'व्यक्तिगत जानकारी',
	['搜寻快捷语']: 'खोज संक्षिप्ताक्षर',
	['登出']: 'लॉगआउट',
	['帐密错误']: 'खाता पासवर्ड गलत',
	['一']: 'एक',
	['二']: 'दो',
	['三']: 'तीन',
	['四']: 'चार',
	['五']: 'पाँच',
	['六']: 'छह',
	['七']: 'सात',
	['请输入客服本名、客服昵称等关键字']: 'कृपया ग्राहक सेवा का असली नाम, ग्राहक सेवा उपनाम आदि कीवर्ड दर्ज करें',
	['共 {{count}} 筆资料']: 'कुल {{count}} डेटा',
	['平台语言不能为空']: 'प्लेटफ़ॉर्म भाषा खाली नहीं हो सकती',
	['开启']: 'खोलना',
	['语言']: 'भाषा',
	['切换语言']: 'भाषा बदलें',
	['语言名称']: 'भाषा का नाम',
	['系统设定']: 'सिस्टम सेटिंग',
	['储存成功']: 'संग्रह सफल',
	['发布成功']: 'सफलतापूर्वक प्रकाशित',
	['复制成功']: 'कॉपी सफल',
	['项目选取']: 'आइटम चयन',
	['图像']: 'चित्र',
	['角色']: 'चरित्र',
	['新增帐号']: 'नया खाता',
	['角色不能为空']: 'भूमिका खाली नहीं हो सकती',
	['登入密码']: 'लॉगिन पासवर्ड',
	['请输入代号、名称、备注等关键字']: 'कृपया कोड, नाम, टिप्पणी आदि कीवर्ड दर्ज करें',
	['确定删除此团队?']: 'क्या आप इस टीम को हटाना सुनिश्चित करते हैं?',
	['切换语言成功']: 'भाषा सफलतापूर्वक बदल दी गई है',
	['确定要切换语言?']: 'क्या आप वास्तव में भाषा बदलना चाहते हैं?',
	['选项']: 'विकल्प',
	['选择语言']: 'भाषा चुनें',
	['修改成功']: 'संशोधन सफल',
	['舊登入密码']: 'पुराना लॉगिन पासवर्ड',
	['確認新登入密码']: 'नया लॉगिन पासवर्ड पुष्टि करें',
	['语言切换成功，將重整页面以套用更新']: 'भाषा स्विच सफल, अपडेट लागू करने के लिए पृष्ठ को फिर से लोड किया जाएगा।',
	['笔 / 页']: 'पन्ना / पन्ना',
	['时段搜寻']: 'समय अवधि खोज',
	['请选择时段']: 'कृपया समय चुनें',
	['更换背景色']: 'पृष्ठभूमि का रंग बदलें',
	['设定背景颜色成功']: 'बैकग्राउंड रंग सफलतापूर्वक सेट किया गया',
	['请重新登入']: 'कृपया फिर से लॉगिन करें',
	['绑定谷歌验证']: 'गूगल प्रमाणन बंधन',
	['解除绑定']: 'बंदिशें हटाें',
	['谷歌验证状态']: 'गूगल सत्यापन स्थिति',
	['已绑定']: 'बाँध लिया गया',
	['未绑定']: 'अनबांडेड',
	['解绑谷歌验证失败']: 'गूगल प्रमाणीकरण अयशस्वी',
	['二维码方式添加']: 'क्यूआर कोड के माध्यम से जोड़ें',
	['请在 Google 身份验证器中采用添加条形码方式添加']: ' कृपया Google प्रमाणीकरणकर्ता में बारकोड जोड़ने का तरीका अपनाएं।',
	['密钥方式添加']: 'की-मैथड जोड़ें',
	['请在 Google 身份验证器中采用输入提供的密钥方式添加']: 'कृपया Google प्रमाण authentication में प्रदान की गई कुंजी विधि का उपयोग करके जोड़ें।',
	['密钥如下所示']: 'कुंजी निम्नलिखित है',
	['请再次输入登入密码']: 'कृपया फिर से प्रवेश पासवर्ड दर्ज करें',
	['谷歌6位动态密码']: 'गूगल 6 अंकों का गतिशील पासवर्ड',
	['请绑定谷歌验证']: 'कृपया गूगल प्रमाणीकरण बाइंड करें',
	['谷歌验证绑定成功']: 'गूगल सत्यापन बंधन सफल',
	['解绑谷歌验证成功']: 'गूगल सत्यापन सफलतापूर्वक अक्षम किया गया',
	['确定解绑谷歌验证？']: 'क्या आप गूगल प्रमाणीकरण को अज्ञात करना चाहते हैं?',
	['请输入谷歌动态码']: 'कृपया गूगल डाइनामिक कोड दर्ज करें',
	['谷歌动态码']: 'गूगल डायनैमिक कोड',
	['谷歌动态码不能为空']: 'गूगल डायनैमिक कोड खाली नहीं हो सकता',
	['谷歌动态码长度6码']: 'गूगल डायनामिक कोड की लंबाई 6 अंकों की है',
	['谷歌动态码错误']: 'गूगल डाइनामिक कोड त्रुटि',
	['內容']: '内容',
	['搜寻']: 'खोजना',
	['连线中断，点击“确定”即重新连线客服。']: 'कनेक्शन टूट गया है, "ठीक है" पर क्लिक करके आप ग्राहक सेवा से पुनः कनेक्ट हो सकते हैं।',
	['充值表单']: 'रिचार्ज फॉर्म',
	['网银充值']: 'नेट बैंकिंग से रिचार्ज',
	['扫码充值']: 'रिचार्ज करने के लिए कोड स्कैन करें',
	['带入目前帐号']: 'वर्तमान खाता में लॉगिन करें',
	['自行输入平台帐号']: 'स्वयं प्लेटफ़ॉर्म खाता दर्ज करें',
	['充值方式']: 'रिचार्ज का तरीका (या भुगतान विधि)',
	['平台帐号']: 'प्लेटफ़ॉर्म खाता',
	['充值金额']: 'रिचार्ज राशि',
	['付款人姓名']: 'भुगतानकर्ता का नाम',
	['确认语']: 'पुष्टि भाषा',
	['操作时间']: 'संचालन समय',
	['操作者']: 'संचालक',
	['请输入备注等关键字']: 'कृपया टिप्पणियाँ और अन्य प्रमुख शब्द दर्ज करें',
	['操作类型']: 'आपरेशन प्रकार',
	['修改平台昵称']: 'प्लेटफ़ॉर्म उपनाम सुधारें',
	['修改平台昵称成功']: 'प्लेटफॉर्म उपनाम संशोधित सफल हुआ',
	['输入格式错误']: 'इनपुट प्रारूप गलत है',
	['套用']: 'लागू करना',
	['确定套用到']: 'निश्चित रूप से लागू करें',
	['套用成功']: 'सफलतापूर्वक लागू किया गया',
	['储存方式']: 'संचयन विधि',
	['储存時間']: 'संग्रहण समय',
	['系统发布']: 'सिस्टम发布',
	['手动储存']: 'हैंडल्ड स्टोरेज',
	['自动储存']: 'स्वचालित संग्रह',
	['预览']: 'पूर्वावलोकन',
	['最多350个字']: 'अधिकतम 350 शब्द',
	['修改']: 'संशोधन',
	['共同资讯管理']: 'साझा सूचना प्रबंधन',
	['共同资讯创建成功']: 'साझा जानकारी सफलतापूर्वक बनाई गई',
	['共同资讯修改成功']: 'साझा जानकारी सफलतापूर्वक संशोधित की गई',
	['新增共同资讯']: 'नया साझा जानकारी',
	['修改共同资讯']: 'संशोधित सामूहिक जानकारी',
	['删除成功']: 'हटाना सफल',
	['已设置于其他答案，无法删除']: 'अन्य उत्तरों में सेट किया गया है, हटाया नहीं जा सकता',
	['请输入名称、内容等关键字']: 'कृपया नाम, सामग्री आदि कीवर्ड दर्ज करें',
	['确定删除此共同资讯？']: 'क्या आप इस साझा जानकारी को हटाने के लिए निश्चित हैं?',
	['共同资讯']: 'साझा जानकारी',
	['尚未选择共同资讯']: 'अभी साझा जानकारी नहीं चुनी गई है',
	['选择共同资讯']: 'चुनें सामान्य जानकारी',
	['选择']: 'चुनें',
	['点击「确定」后，即覆盖该平台的快捷语设定']: '\'ठीक है\' पर क्लिक करने के बाद, इस प्लेटफार्म की शॉर्टकट सेटिंग को अधिलेखित कर दिया जाएगा।',
	['已复制：目的平台']: 'प्रतिनिधि मंच',
	['是否离开客服系统？']: 'क्या आप कस्टमर सर्विस सिस्टम से बाहर जाना चाहते हैं？',
	['感谢您的作答，此次评分为：{{score}}分']: 'आपके उत्तर के लिए धन्यवाद, इस बार आपकी रेटिंग है: {{score}} अंक',
	['共 {{count}} 筆']: 'कुल {{count}} प्रविष्टियाँ',
	['分']: 'विभाजन',
	['新增公司']: 'नई कंपनी',
	['翻译']: 'अनुवाद',
	['显示原文']: 'मूल पाठ दिखाएं',
	['解绑谷歌验证']: 'गूगल प्रमाणन को अकारण करना',
	['请输入名称 内容等关键字']: 'कृपया नाम, सामग्री आदि कीवर्ड दर्ज करें',
	['表单选项']: 'प्रपत्र विकल्प',
	['年']: 'साल',
	['等待时间颜色设定']: 'अवधि समय रंग सेटिंग',
	['显示颜色']: 'रंग दिखाना',
	['确认删除此规则?']: 'इस नियम को हटाने की पुष्टि करें?',
	['页签']: 'टैब',
	['超过 {{time}} 分钟']: 'ज्यादा {{time}} मिनट',
	['新增成功']: 'नया सफलतापूर्वक जोड़ा गया',
	['删除完成']: 'हटाना पूरा हुआ',
	['等待时间(分钟)']: 'प्रतीक्षा समय (मिनट)',
	['时间']: 'समय',
	['不可为空']: 'खाली नहीं हो सकता',
	['需为正整数']: 'सकारात्मक पूर्णांक होना चाहिए',
	['按平台名称排列(A-Z)']: 'प्लेटफॉर्म के नाम के अनुसार क्रमबद्ध करें (A-Z)',
	['按平台名称排列(Z-A)']: 'प्लेटफ़ॉर्म के नाम के अनुसार क्रमबद्ध करें (Z-A)',
	['旧版面模式']: 'पुराना लेआउट मोड',
	['自动翻译']: 'स्वचालित अनुवाद',
	['功能設定']: 'कार्य सेटिंग',
	['确认切换版面？']: 'क्या आप लेआउट स्विच करने की पुष्टि करना चाहते हैं?',
	['确认开启自动翻译？']: 'क्या आप स्वचालित अनुवाद चालू करना चाहते हैं?',
	['确认关闭自动翻译？']: 'क्या आप स्वचालित अनुवाद बंद करने की पुष्टि करते हैं?',
	['原文']: 'मूल पाठ',
	['泰语']: 'थाई भाषा',
	['追踪']: 'अनुसरण',
	['取消追踪']: 'अनफॉलो',
	['预览影片']: 'प्रस्तावित वीडियो',
	['仅能上传 MP4、MOV、 JPEG (JPG)、PNG、 GIF、HEIC、RAW、HEIF档案']: 'केवल MP4, MOV, JPEG (JPG), PNG, GIF, HEIC, RAW, HEIF फाइलें अपलोड कर सकते हैं',
	['请勿输入语法相关字串']: 'कृपया किसी भी प्रकार का कोड या विशेष वर्ण दर्ज न करें',
	['输入名称']: 'इनपुट नाम',
	['设为预设版本']: 'डिफ़ॉल्ट संस्करण बनाएं',
	['另存为新版本']: 'नए संस्करण के रूप में सहेजें',
	['请选择版本']: 'कृपया संस्करण चुनें',
	['一键开关']: 'एक-क्लिक स्विच',
	['若有服务中的客户，无法关闭服务平台与切换版本']: 'यदि सेवा में ग्राहक हैं, तो सेवा प्लेटफ़ॉर्म को बंद नहीं किया जा सकता और संस्करणों को स्विच नहीं किया जा सकता।',
	['是否确认要覆盖已有的设定，储存新的设定？']: 'क्या आप मौजूदा सेटिंग को ओवरराइट करने और नई सेटिंग को सहेजने की पुष्टि करते हैं?',
	['已储存超过五个版本']: 'पांच से अधिक संस्करण सहेजे गए हैं',
	['版本已变动，是否需要储存？']: 'संस्करण में परिवर्तन हुआ है, क्या आपको इसे सहेजने की आवश्यकता है?',
	['确定删除此版本？']: 'क्या आप इस संस्करण को हटाने की पुष्टि करते हैं?',
	['编辑版本']: 'संस्करण संपादित करें',
	['侦测到重复联系客服系统，若非您本人请告知客服']: 'ग्राहक सेवा से बार-बार संपर्क किया जा रहा है। यदि यह आप नहीं हैं, तो कृपया हमें सूचित करें।',
	['删除此版本']: 'इस संस्करण को हटाएं',
	['刪除成功']: ' हटाना सफल',
	['刪除失敗']: 'हटाने में विफल',
	['儲存成功']: 'सफलता से सहेजा गया',
	['儲存失敗']: 'सहेजने में विफल',
	['您好，请问要选择哪个问题？']: 'नमस्ते, कृपया बताएं आप कौन-सा प्रश्न चुनना चाहेंगे？',
	['等待服务区']: 'सेवा क्षेत्र की प्रतीक्षा करना',
	['按时间排列(長到短)']: 'समय के अनुसार क्रमबद्ध (लंबे से छोटे)',
	['按时间排列(短到長)']: 'समय के अनुसार क्रमबद्ध (छोटा से बड़ा)',
	['亲, 欢迎您的到来～很高兴为您服务，请先别著急，我们即将为您提供服务 ...']: 'प्रिय ग्राहक, आपका स्वागत है! आपकी सेवा करके हमें खुशी होगी। कृपया थोड़ा धैर्य रखें, हम जल्द ही आपकी सहायता करेंगे…',
	['编辑标签']: 'संपादित टैग',
	['于 {{time}} 侦测到会员【稍早已离线】']: '{{time}} पर सदस्य 【थोड़ी देर पहले ऑफलाइन】 का पता लगाया गया',
	['{{score}}分']: '{{score}} अंक',
	['未评分']: 'अनमानित',
	['客服完成']: 'ग्राहक सेवा पूर्ण',
	['会员离线']: 'सदस्य ऑफ़लाइन',
	['超时自动断线']: '超 समय स्वचालित断线',
	['{{text}}不可重复']: '{{text}}अभिनव नहीं हो सकता',
	['{{text}}不能为空']: '{{text}} नहीं हो सकता',
	['{{text}}设置错误']: '{{text}} सेटिंग्स में त्रुटि',
	['平均通话时长']: 'औसत कॉल अवधि',
	['平均通话数']: 'औसत कॉल संख्या',
	['请选择角色名称']: 'किरदार का नाम चुनें',
	['请选择客服']: 'कृपया ग्राहक सेवा चुनें',
	['请选择团队']: 'कृपया टीम चुनें',
	['播放']: 'चलाना',
	['统计时间']: 'सांख्यिकी समय',
	['统计时间不可为空']: 'सांख्यिकी का समय रिक्त नहीं हो सकता',
	['请输入时间']: 'कृपया समय दर्ज करें',
	['时间筛选']: 'समय छानना',
	['汇出']: 'निर्यात',
	['未出勤']: 'अनुपस्थिति',
	['客服平均通话时长']: 'ग्राहक सेवा का औसत कॉल समय',
	['数量筛选']: 'संख्यात्मक चयन',
	['客服平均等待时间']: 'ग्राहक सेवा की औसत प्रतीक्षा समय',
	['上一个月']: 'पिछला महीना',
	['导出Excel成功']: 'Excel में निर्यात सफल',
	['对话结束']: 'वार्तालाप समाप्त',
	['满意度/客服']: 'संतोष / ग्राहक सेवा',
	['日期/客服']: 'तारीख/ग्राहक सेवा',
	['总数']: 'कुल',
	['日平均']: 'दैनिक औसत',
	['客服日均量']: 'ग्राहक सेवा दैनिक मात्रा',
	['客服通话总量']: 'ग्राहक सेवा कॉल कुल',
	['日总量']: 'दिन का कुल量',
	['请输入数量']: 'कृपया मात्रा दर्ज करें',
	['满意度预设分数']: 'संतोष स्तर पूर्व निर्धारित अंक',
	['当会员未评分，会自动给予此预设分数。']: 'जब सदस्य ने मूल्यांकन नहीं किया है, तो स्वचालित रूप से इस पूर्व निर्धारित स्कोर को दिया जाएगा।',
	['设定满意度预设分数成功']: 'संतोष स्तर पूर्वनिर्धारित स्कोर सफलतापूर्वक सेट किया गया।',
	['客户满意度管理']: 'ग्राहक संतोष प्रबंधन',
	['对话结束方式']: 'संवाद समाप्ति का तरीका',
	['对话满意度']: 'संवाद संतोष',
	['时段']: 'अवधि',
	['客服平均满意度']: 'ग्राहक सेवा औसत संतोष',
	['公用设定']: 'सार्वजनिक सेटिंग',
	['通话时长']: 'वार्ता की अवधि',
	['服务时段']: 'सेवा समय',
	['储存时间']: 'भंडारण समय',
	['客服不可为空']: 'ग्राहक सेवा खाली नहीं हो सकती',
	['团队不可为空']: 'टीम खाली नहीं हो सकती',
	['请输入对话内容关键字']: 'कृपया वार्ता सामग्री की कुंजी शब्द दर्ज करें',
	['请输入客服本名、昵称或帐号']: 'कृपया ग्राहक सेवा का असली नाम, उपनाम या खाता दर्ज करें',
	['平台不可为空']: 'प्लेटफॉर्म खाली नहीं हो सकता',
	['线上']: 'ऑनलाइन',
	['离线']: 'ऑफलाइन',
	['日期不可为空']: 'तारीख खाली नहीं हो सकती',
	['亲，跟您再次确认下，申请并进行此笔充值 {{chargeNumber}} 元的帐号是 {{chargeAccount}}，对吗？']: 'प्रिय, मैं आपसे फिर से पुष्टि करना चाहता हूँ कि इस बार के लिए आवेदन और किया गया यह रिचार्ज {{chargeNumber}} रुपये का खाता {{chargeAccount}} है, है ना?',
	['您的等待顺位为第 {{pendingOrder}} 位']: 'कतार में आपका नंबर: {{pendingOrder}}',
	['拒絕由 {{inviter}} 转接至 {{invitee}}']: '{{inviter}} से {{invitee}} में स्थानांतरित करने से मना करें',
	['{{name}} 已于 {{time}} 关闭视窗']: '{{name}} ने {{time}} विंडो बंद कर दी',
	['{{name}} 已于 {{time}} 点选案件完成']: '{{name}} ने {{time}} बजे मामले को पूरा किया',
	['{{name}} 已于 {{time}} 成功加入协作']: '{{name}} ने {{time}} को सहयोग में सफलतापूर्वक शामिल हो गया',
	['{{name}} 已于 {{time}} 离开协作']: '{{name}} ने {{time}} को सहयोग छोड़ दिया',
	['{{name}} 已于 {{time}} 中断连线']: '{{name}} ने {{time}} में कनेक्शन काट दिया。',
	['英文']: 'अंग्रेजी',
	['验证码设定']: 'कैप्चा सेटिंग',
	['启用验证码']: 'कैप्चा सक्षम करें',
	['设定验证码成功']: '验证码 सेटिंग सफल',
	['启用验证码功能后，客户需完成验证才能进入客服系统等待区。']: 'कैप्चा सुविधा सक्रिय करने के बाद, ग्राहक को ग्राहक सेवा प्रणाली के प्रतीक्षा क्षेत्र में प्रवेश करने के लिए सत्यापन पूरा करना होगा।',
	['禁止连续发话']: 'कृपया लगातार संदेश न भेजें',
	['启用禁止连续发话']: 'एकल वार्तालाप निषेध सक्षम करें',
	['当会员在「限制秒数」内发话超过设定的次数，系统将会自动跳警告。']: 'जब सदस्य "सीमित सेकंड" के भीतर निर्धारित次数 से अधिक बात करते हैं, तो सिस्टम स्व automatic चेतावनी देगा।',
	['客户端限制于']: 'ग्राहक तरफा सीमित है',
	['发话次数达到']: 'बोलने की次数达到',
	['次']: 'अगला',
	['暂时无法发话']: 'अस्थायी रूप से बोलने में असमर्थ',
	['储存完成']: 'सहेजना पूरा',
	['发送消息过于频繁 可稍后再试']: 'अतिरिक्त संदेश भेजने के लिए बहुत बार, कृपया बाद में पुनः प्रयास करें।',
	['IP黑名单管理']: 'IP ब्लैकलिस्ट प्रबंधन',
	['共 {{total}} 笔']: 'कुल {{total}} लेनदेन',
	['第 {{min}} - {{max}} 笔/共 {{total}} 笔']: '第 {{min}} - {{max}} पत्ते/कुल {{total}} पत्ते',
	['顯示']: 'प्रदर्शित करें',
	['查询IP黑名单']: 'आईपी ब्लैकलिस्ट की जांच करें',
	['设定自动添加黑名单']: 'स्वचालित ब्लैकलिस्ट जोड़ने की सेटिंग',
	['白名單管理']: 'श्वेतसूची प्रबंधन',
	['解除时间']: 'समय समाप्त करें',
	['永久封锁']: 'स्थायी लॉकडाउन',
	['新增IP黑名单']: 'नया आईपी ब्लैकलिस्ट जोड़ें',
	['加入黑名单后，该IP将无法进入客服前台。']: 'ब्लैक लिस्ट में शामिल होने के बाद, यह आईपी ग्राहक सेवा के फ्रंट डेस्क में प्रवेश नहीं कर पाएगा।',
	['请完成安全验证']: 'कृपया सुरक्षा सत्यापन पूरा करें',
	['向右滑动填充拼图']: 'पहेली को पूरा करने के लिए दाईं ओर स्लाइड करें',
	['启用功能']: 'सक्षम करें',
	['若IP于「限制时间」内登入超过设定的「登入次数」系统即自动加入黑名单。']: 'यदि आईपी \'सीमित समय\' के भीतर निर्धारित \'लॉगिन次数\' से अधिक लॉगिन करता है, तो प्रणाली स्वतः काले सूची में जोड़ देती है।',
	['限制时间']: 'सीमा समय',
	['时间单位不可为空']: 'समय इकाई खाली नहीं हो सकती',
	['时间单位']: 'समय इकाई',
	['登入次数']: 'लॉगिन次数',
	['封锁时间']: 'बंद करने का समय',
	['锁的持续时间，时间到了会自动解除']: 'ताले की स्थिरता, समय पर खुद-ब-खुद रद्द हो जाएगा',
	['查询IP白名单']: 'IP श्वेतसूची की जांच करें',
	['删除失败']: 'हटाना विफल रहा',
	['修改失败']: 'संशोधन असफल',
	['拼图验证失败次数过多']: 'पहेली सत्यापन बहुत बार विफल रहा',
	['{{name}} 已于 {{time}} 拒絕加入协作']: '{{name}} ने {{time}} को सहयोग में शामिल होने से इनकार कर दिया',
	['储存过滤模組成功']: 'भंडारण फ़िल्टर मॉड्यूल सफलतापूर्वक',
	['删除过滤模組成功']: 'फिल्टर मॉड्यूल सफलतापूर्वक हटाया गया',
	['解除谷歌验证成功']: 'गूगल प्रमाणीकरण सफलतापूर्वक हटा दिया गया',
	['确定禁用平台?']: 'क्या आप प्लेटफ़ॉर्म को निष्क्रिय करने की पुष्टि करते हैं?',
	['确定启用平台?']: 'प्लेटफ़ॉर्म को सक्रिय करना सुनिश्चित करें?',
	['IP管理(客户端)']: 'आईपी प्रबंधन (क्लाइंट)',
	['上传']: 'अपलोड',
	['此栏位的时间会使用于报表的团队筛选']: 'इस कॉलम का समय रिपोर्ट की टीम फ़िल्टर में उपयोग किया जाएगा।',
	['选择团队：筛选出该团队所有客服人员在团队统计时间中的数据']: 'टीम चुनें: इस टीम के सभी ग्राहक सेवा प्रतिनिधियों के डेटा को टीम सांख्यिकी समय में फ़िल्टर करें',
	['备注最多{{inputLimit}}个字']: 'नोट में अधिकतम {{inputLimit}} अक्षर हों',
	['{{inviter}} 已于 {{time}} 将对话从 {{from}} 转接给 {{invitee}}']: '{{inviter}} ने {{time}} को बातचीत {{from}} से {{invitee}} को स्थानांतरित किया',
	['小时']: 'घंटा',
	['日']: 'दिन',
	['会员IP：{{ip}} 已加入前台黑名单']: 'सदस्य आईपी：{{ip}} अग्रभाग की काली सूची में जोड़ा गया',
	['新增失败']: 'नई जोड़ने में विफल',
	['会员IP被加入黑名单']: 'सदस्य आईपी काले सूची में जोड़ा गया।',
	['登入/接待时间']: 'लॉगिन/स्वागत समय',
	['timePeriodTooltipMessage']: 'समय अवधि टूलटिप संदेश',
	['平均接待时间']: 'औसत स्वागत समय',
	['平均登入时间']: 'औसत लॉगिन समय',
	['接待时间报表']: 'स्वागत समय रिपोर्ट',
	['登入时间报表']: 'लॉगिन समय रिपोर्ट',
	['未登入']: 'लॉगिन नहीं किया',
	['设定报表']: 'रिपोर्ट सेट करें',
	['设定对话是否记入报表中']: 'बातचीत को रिपोर्ट में शामिल करने के लिए सेट करें',
	['平均通话时长报表']: 'औसत कॉल अवधि रिपोर्ट',
	['平均通话数报表']: 'औसत कॉल संख्या रिपोर्ट',
	['平均等待时间报表']: 'औसत प्रतीक्षा समय रिपोर्ट',
	['客户满意度报表']: 'ग्राहक संतोष रिपोर्ट',
	['平均回覆时间报表']: 'औसत उत्तर समय रिपोर्ट',
	['调整原因']: 'समायोजन कारण',
	['请输入调整原因']: 'कृपया समायोजन का कारण दर्ज करें',
	['调整原因不可为空']: 'समायोजन का कारण खाली नहीं हो सकता',
	['日期时间']: 'तारीख और समय',
	['操作人']: 'प्रचालक',
	['原因']: 'कारण',
	['更多']: 'और अधिक',
	['收回']: 'खींचना',
	['设定报表成功']: 'रिपोर्ट सेटिंग सफल',
	['平均回覆时间']: 'औसत प्रतिक्रिया समय',
	['客服平均回覆时间']: 'ग्राहक सेवा औसत प्रतिक्रिया समय',
	['客户回头率']: 'ग्राहक प्रतिधारण दर',
	['客户ID']: 'ग्राहक आईडी',
	['客服帐号']: 'ग्राहक सेवा खाता',
	['小时回头率']: 'घंटों का रेट्रो स्पेक्‍ट्रम',
	['日回头率']: 'दैनिक वापसी दर',
	['遗漏时间']: 'समय की कमी',
	['请选择遗漏时间']: 'कृपया छूटे हुए समय का चयन करें',
	['平均遗漏时间']: 'औसत छूट समय',
	['1分钟']: '1 मिनट',
	['2分钟']: '2 मिनट',
	['3分钟']: '3 मिनट',
	['4分钟']: '4 मिनट',
	['5分钟']: '5 मिनट',
	['离开时间']: 'जाने का समय',
	['客户回头率报表']: 'ग्राहक पुनरावृत्ति रिपोर्ट',
	['平台报表']: 'प्लेटफॉर्म रिपोर्ट',
	['对话总量']: 'संवाद कुल',
	['接待总量']: 'स्वागत कुल',
	['遗漏总量']: 'छूट कुल',
	['智能客服总量']: 'स्मार्ट ग्राहक सेवा कुल मात्रा',
	['智能转客服总量']: 'स्मार्ट कस्टमर सर्विस कुल मात्रा',
	['最后更新时间']: 'अंतिम अपडेट समय',
	['客服人数']: 'ग्राहक सेवा संख्या',
	['在线客服总数']: 'ऑनलाइन ग्राहक सेवा कुल संख्या',
	['等待服务']: 'सेवा का इंतजार',
	['正在服务']: 'सेवा कर रहा हूँ',
	['智能未转客服总量']: 'स्मार्ट अनरूटेड ग्राहक सेवा की कुल मात्रा',
	['使用平台']: 'प्लेटफार्म का उपयोग',
	['泰文名称']: 'थाई नाम',
	['请输入泰文名称']: 'कृपया थाई नाम दर्ज करें',
	['英文名称']: 'अंग्रेज़ी नाम',
	['请输入英文名称']: 'कृपया अंग्रेजी नाम दर्ज करें',
	['中文名称']: 'चीन की नाम',
	['请输入中文名称']: 'कृपया चीनी नाम दर्ज करें',
	['若无需翻译请填写中文']: 'यदि अनुवाद की आवश्यकता नहीं है तो कृपया चीनी भरें',
	['帐号所有报表数据将连同帐号一同删除，请问确认要删除吗？']: 'खाता सभी रिपोर्ट डेटा को खाते के साथ ही हटा दिया जाएगा, क्या आप हटाने की पुष्टि करना चाहते हैं?',
	['停用']: 'बंद करना',
	['停用帐号']: 'खाता निष्क्रिय करें',
	['通话总数']: 'कॉल की कुल संख्या',
	['等待中人数：{{pendingConversationCount}} 人']: 'प्रतीक्षा में लोगों की संख्या: {{pendingConversationCount}} लोग',
	['报表正在汇出中，请前往页面「报表下载」查看进度并进行下载。']: 'रिपोर्ट निर्यात पर है, कृपया "रिपोर्ट डाउनलोड" पृष्ठ पर अपनी प्रगति देखने और डाउनलोड करने के लिए जाएं।',
	['汇出Load Data']: 'निलंबित लोड डेटा',
	['报表下载']: 'रिपोर्ट डाउनलोड',
	['全平台']: 'सम्पूर्ण प्लेटफॉर्म',
	['报表类型']: 'रिपोर्ट का प्रकार',
	['数据范围']: 'डेटा रेंज',
	['汇出时间']: 'निर्यात समय',
	['完成时间']: 'पूर्णता समय',
	['申请者']: 'आवेदक',
	['下载']: 'डाउनलोड',
	['重新汇出']: 'फिर से निर्यात करें',
	['处理中']: 'प्रसंस्करण',
	['已完成']: 'पूर्ण हुआ',
	['失败']: 'विफलता',
	['下载成功']: 'डाउनलोड सफल',
	['历史对话纪录']: 'इतिहास वार्ता रिकॉर्ड',
	['连线中断，请点击确定尝试恢复连线，若无法恢复将结束对话。']: 'कनेक्शन बाधित हो गया है। कृपया ‘ठीक है’ पर क्लिक करके पुनः प्रयास करें。\nयदि कनेक्शन बहाल नहीं होता है तो वार्तालाप समाप्त कर दिया जाएगा。',
	['引用功能管理']: 'उद्धरण फ़ंक्शन प्रबंधन',
	['引用对话']: 'उद्धृत वार्ता',
	['设定引用对话成功']: 'उद्धरण संवाद सफलतापूर्वक सेट किया गया',
	['客户管理']: 'ग्राहक प्रबंधन',
	['重要客户帐号']: 'महत्वपूर्ण ग्राहक खाता',
	['请输入重要客户帐号、备注等关键字']: 'कृपया महत्वपूर्ण ग्राहक खाता, टिप्पणी आदि कुंजी शब्द दर्ज करें',
	['新增重要客户']: 'महत्वपूर्ण ग्राहक जोड़ें',
	['重要客户帐号不能为空']: 'महत्वपूर्ण ग्राहक खाता खाली नहीं हो सकता।',
	['输入多个帐号请用, 区隔']: 'एक से अधिक खाते दर्ज करने के लिए कृपया \',\' का उपयोग करें',
	['修改重要客户']: 'महत्वपूर्ण ग्राहक संशोधित करें',
	['重要帐号']: 'महत्वपूर्ण खाता',
	['会员类型']: 'सदस्य प्रकार',
	['引用']: 'उद्धरण',
	['收回(訊息)']: 'रिवोक करें',
	['收回功能管理']: 'फунк्शन प्रबंधन वापस लेना',
	['收回提示文字不能为空']: 'नोटिस टेक्स्ट रिकवर नहीं हो सकता',
	['收回对话']: 'संवाद वापस लेना',
	['收回提示文字（中文）']: 'सर्व提示文字 वापस लें',
	['收回提示文字（英文）']: 'सूचना वापस लें',
	['收回提示文字（泰文）']: 'सूचना को वापस लें (थाई)',
	['视频']: 'वीडियो',
	['确定要收回讯息吗？']: 'क्या आप वास्तव में संदेश को वापस लेना चाहते हैं?',
	['设定收回功能成功']: 'सेटिंग पुनःप्राप्ति कार्य सफल',
	['遗漏数据']: 'डेटा का नुकसान',
	['全选']: 'सभी चुनें',
	['请选择使用平台']: 'कृपया प्लेटफ़ॉर्म चुनें',
	['日期计算方式']: 'तारीख़ की गणना का तरीका',
	['以会员进入正在服务区的时间计算']: 'सदस्य के द्वारा सेवा क्षेत्र में प्रवेश करने के समय की गणना करें',
	['以会员进入等待服务区的时间计算，若是点击智能客服未进入等待服务区则以点入智能客服的时间计算']: 'यदि सदस्य सेवा क्षेत्र में प्रतीक्षा करने के समय की गणना करते हैं, यदि स्मार्ट客服 पर क्लिक करने के बाद सेवा क्षेत्र में नहीं जाते हैं तो स्मार्ट客服 पर क्लिक करने का समय की गणना की जाएगी।',
	['以会员进入等待服务区的时间计算']: 'सदस्य के सेवा क्षेत्र में प्रवेश करने के लिए प्रतीक्षा समय की गणना करें',
	['以客服接通对话的时间进行计算']: 'ग्राहक सेवा के संपर्क में बातचीत के समय का आधार लेकर गणना करना',
	['以会员进入等待服务区的时间进行计算']: 'सदस्य के इंतजार करने के क्षेत्र में प्रवेश के समय का उपयोग करके गणना करना',
	['以会员点击智能客服的时间计算']: 'सदस्य द्वारा स्मार्ट ग्राहक सेवा पर क्लिक करने के समय की गणना करना',
	['相同类型才会计算回头']: 'समान प्रकार ही वापस गणना करेगा',
	['登入联系离开后再次登入联系']: 'लॉगिन संपर्क छोड़ने के बाद फिर से लॉगिन संपर्क',
	['一通对话只会触发一次回头次数']: 'एक वार्तालाप केवल एक बार वापसी की संख्या को सक्रिय करेगा',
	['同一会员时间内连续联系3次，计算前两通对话的客服各1次回头']: 'समान सदस्यता समय में लगातार 3 बार संपर्क करने पर, पहले दो वार्तालापों की ग्राहक सेवा प्रत्येक को 1 बार वापस किया जाएगा।',
	['每日同一会员于对话结束后{{hour}}小时内又重复联系的有效对话比例']: 'प्रत्येक दिन एक ही सदस्य द्वारा बातचीत समाप्त होने के {{hour}} घंटे भीतर फिर से संपर्क करने वाली प्रभावी बातचीत का अनुपात',
	['未登入联系离开后再次未登入联系']: 'बिना लॉग इन संपर्क छोड़ने के बाद फिर से बिना लॉग इन संपर्क',
	['请输入重要客户帐号']: 'महत्वपूर्ण ग्राहक खाता दर्ज करें',
	['开始日期']: 'शुरुआत तिथि',
	['结束日期']: 'समाप्ति तिथि',
	['标签名称/数量']: 'लेबल नाम/संख्या',
	['暂无数据']: 'अभी डेटा नहीं है',
	['AI客服设定']: 'एआई ग्राहक सेवा सेटिंग',
	['AI共同设定']: 'एआई सह-निर्धारण',
	['平台AI设定']: 'प्लेटफॉर्म एआई सेटिंग',
	['平台 AI SKILL 设定']: 'प्लेटफॉर्म एआई SKILL सेटिंग',
	['指令输入说明']: 'निर्देशन इनपुट विवरण',
	['输入文字档']: 'इनपुट टेक्स्ट फ़ाइल',
	['不需要区分功能']: 'कार्यात्मकता में भेद करने की आवश्यकता नहीं है',
	['套用平台']: 'लागू मंच',
	['请输入指令']: 'कृपया आदेश दर्ज करें',
	['AI与会员对话超过 <<inputNumber>> 轮后需要通知客服人员']: 'AI और सदस्य के बीच <<inputNumber>> राउंड के बाद ग्राहक सेवा कर्मचारी को सूचित करने की आवश्यकता है',
	['指令']: 'निर्देश',
	['AI开关']: 'एआई स्विच',
	['AI客服名称']: 'एआई ग्राहक सेवा नाम',
	['AI客服名称不能为空']: 'AI客服 नाम खाली नहीं हो सकता',
	['请输入AI客服名称']: 'कृपया AI ग्राहक सेवा का नाम दर्ज करें',
	['是否要关闭AI客服？关闭后将无法再度开启AI客服']: 'क्या आपको एआई ग्राहक सेवा बंद करनी है? बंद करने पर आप एआई ग्राहक सेवा को फिर से शुरू नहीं कर सकेंगे।',
	['侦测到对话有异常状态，请尽快处理']: 'बातचीत में असामान्य स्थिति का पता चला है, कृपया इसे तुरंत संभालें।',
	['需要转接人工客服，请尽快处理']: 'सपोर्ट एजेंट को हस्तांतरित करने की आवश्यकता है, कृपया इसे शीघ्र संसाधित करें।',
	['总平均通话时长']: 'कुल औसत कॉल की अवधि',
	['AI平均通话时长']: 'AI औसत वार्तालाप अवधि',
	['人工平均通话时长']: 'कृत्रिम औसत वार्तालाप अवधि',
	['每日总平均']: 'दैनिक कुल औसत',
	['AI日平均']: 'AI दिन का औसत',
	['人工日平均']: 'कृत्रिम दैनिक औसत',
	['通话总量']: 'कॉल कुल',
	['AI通话总量']: 'AI कॉल की कुल संख्या',
	['共同']: 'सामूहिक',
	['总计']: 'कुल',
	['总计请勿超过{{limit}}字']: 'कृपया {{limit}} शब्दों से अधिक न हों',
	['总平均回覆时间']: 'सामान्य औसत उत्तर समय',
	['AI平均回覆时间']: 'AI औसत उत्तर समय',
	['人工平均回覆时间']: '人工 औसत प्रतिक्रिया समय',
	['AI日总量']: 'एआई दिन का कुल량',
	['人工日总量']: '人工 दिन कुल मात्रा',
	['指令不能为空']: 'निर्देश खाली नहीं हो सकते',
	['{{name}} 已于 {{time}} 开启AI']: '{{name}} ने {{time}} को AI शुरू किया',
	['{{name}} 已于 {{time}} 关闭AI']: '{{name}} ने {{time}} को AI बंद कर दिया',
	['人机合作日总量']: 'मानव-मशीन सहयोग दैनिक मात्रा',
	['人工通话总量']: 'आर्टिफिशियल कॉल वॉल्यूम',
	['人机合作通话总量']: 'मानव-यंत्र सहयोग कॉल की कुल मात्रा',
	['以对话建立时间计算']: 'संवाद के माध्यम से समय गणना करना',
	['侦测到对话有异常状态 - 对话次数超过限制']: 'बातचीत में असामान्य स्थिति का पता चला है - बातचीत की सीमा पार हो गई है',
	['侦测到对话有异常状态 - 系统发生错误']: 'वार्तालाप में असामान्यता पाई गई — सिस्टम में त्रुटि हुई है',
	['人机合作-人工日平均']: 'मनुष्य- मशीन सहयोग -人工日 औसत',
	['人机合作-AI日平均']: 'मानव-यन्त्र सहयोग - एआई दैनिक औसत',
	['人机合作-人工平均通话时长']: 'मनुष्य-यांत्रिकी सहयोग - मानव द्वारा औसत वार्तालाप अवधि',
	['人机合作-AI平均通话时长']: 'मानव-यंत्र सहयोग-एआई औसत वार्ता अवधि',
	['侦测到对话有异常状态 - 等待AI API超过两分钟']: 'वार्तालाप में असामान्यता पाई गई — AI API की प्रतीक्षा दो मिनट से अधिक हो गई है',
	['侦测到对话有异常状态 - AI 发生错误']: 'बातचीत में असामान्य स्थिति का पता चला है - AI में त्रुटि (Error) हुई है',
	['侦测到对话有异常状态 - AI 没有回复']: 'बातचीत में असामान्य स्थिति का पता चला है - AI से कोई जवाब नहीं मिला',
	['数据']: 'डेटा',
	['指令不能超过{{limit}}字']: 'निर्देश {{limit}} शब्दों से अधिक नहीं हो सकते',
	['数据不能为空']: 'डेटा खाली नहीं हो सकता',
	['数据不能超过100万字']: 'डेटा 1000000 शब्दों से अधिक नहीं होना चाहिए',
	['需{{limit}}字以内']: '需{{limit}}字以内',
	['数据输入说明']: 'डेटा इनपुट निर्देश',
	['需100万字以内']: 'आपको १००000 शब्दों के भीतर होना चाहिए',
	['至少要有一组 ~~~~~ 与 =====']: '~~~~~ और ===== का कम से कम एक जोड़ा होना चाहिए',
	['分隔符号 ~~~~~ 与 ===== 需成对出现']: 'विभाजक ~~~~~ और ===== जोड़े में आने चाहिए',
	['需以 ===== 结尾']: '===== से समाप्त होना चाहिए',
	['标题底下使用5个波浪号并换行，波浪号的开头与结尾不能有其他文字或空格']: 'शीर्षक के नीचे की पंक्ति में 5 टिल्ड लगाएं, उनके आगे या पीछे कोई अन्य टेक्स्ट या स्पेस नहीं होना चाहिए',
	['内容底下使用5个等号并换行，等号的开头与结尾不能有其他文字或空格']: 'सामग्री के नीचे की पंक्ति में 5 बराबर चिह्न लगाएं, उनके आगे या पीछे कोई अन्य टेक्स्ट या स्पेस नहीं होना चाहिए',
	['范例']: 'उदाहरण',
	['标题A（可多行）']: 'शीर्षक A (कई पंक्तियाँ संभव)',
	['内容A（可多行，可含任何文字）']: 'सामग्री A (कई पंक्तियाँ, कोई भी टेक्स्ट हो सकता है)',
	['标题B（可多行）']: 'शीर्षक B (कई पंक्तियाँ संभव)',
	['内容B（可多行，可含任何文字）']: 'सामग्री B (कई पंक्तियाँ, कोई भी टेक्स्ट हो सकता है)',
	['模型顺序（上方模型优先使用，失效时自动往下切换）']: 'मॉडल क्रम (ऊपर वाला मॉडल पहले उपयोग होता है, विफल होने पर स्वतः अगले पर स्विच हो जाता है)',
	['主要']: 'मुख्य',
	['备援{{index}}']: 'बैकअप {{index}}',
	['新增备援模型']: 'बैकअप मॉडल जोड़ें',
	['请输入数据']: 'डेटा डालें',
	['正在转接中...']: 'संक्रमण हो रहा है...',
	['（中文）']: '(चीनी)',
	['（英文）']: '（अंग्रेजी）',
	['（泰文）']: '(थाई)',
	['（越南文）']: '(वियतनामी)',
	['越南文名称']: 'वियतनामी नाम',
	['请输入越南文名称']: 'कृपया वियतनामी नाम दर्ज करें',
	['模式']: 'मॉडल',
	['越南语']: 'वियतनामी',
	['IP白名单设定']: 'IP सफेद सूची सेटिंग',
	['建立时间']: 'निर्माण समय',
	['批次删除']: 'बैच हटाना',
	['请确认是否删除 IP 白名单？']: 'कृपया पुष्टि करें कि आप आईपी व्हाइटलिस्ट हटाना चाहते हैं?',
	['开启快捷选单']: 'क्विक मेन्यू खोलें',
	['收合快捷选单']: 'क्विक मेन्यू बंद करें',
	['是否有收回人员讯息']: 'क्या कर्मचारियों की जानकारी वापस ली गई है?',
	['是否有收回AI讯息']: 'क्या एआई संदेश वापस लिया गया है',
	['消息已被客服撤回']: 'संदेश को ग्राहक सेवा द्वारा वापस ले लिया गया.',
	['用户快捷选单管理']: 'उपयोगकर्ता त्वरित सूची प्रबंधन',
	['电脑预览']: 'कंप्यूटर पूर्वावलोकन',
	['手机预览']: 'मोबाइल पूर्वावलोकन',
	['档案格式：PNG、JPG、JPEG']: 'फ़ाइल प्रारूप: PNG, JPG, JPEG',
	['请选择上传档案']: 'कृपया फ़ाइल अपलोड करने का चयन करें',
	['新增快捷成功']: 'नया शॉर्टकट सफलतापूर्वक जोड़ा गया',
	['修改快捷成功']: 'संशोधन सफलतापूर्वक हुआ',
	['设定快捷选单成功']: 'तेज मेनू सेट करना सफल हुआ',
	['删除快捷成功']: 'हटाने की शॉर्टकट सफलतापूर्वक',
	['确定删除此快捷？']: 'क्या आप इस शॉर्टकट को हटाना चाहते हैं?',
	['新增内容']: 'नया सामग्री',
	['选项內容']: 'विकल्प सामग्री',
	['{{itemLabel}}內容不能为空']: '{{itemLabel}} सामग्री ख़ाली नहीं हो सकती',
	['请输入{{itemLabel}}标题']: 'कृपया {{itemLabel}} शीर्षक दर्ज करें',
	['请输入{{itemLabel}}选项']: 'कृपया {{itemLabel}} विकल्प दर्ज करें',
	['{{text}}不可为空']: '{{text}} खाली नहीं हो सकता',
	['显示更多']: 'और दिखाएँ',
	['公告标签']: 'जुगत प्रभेद',
	['请选择公告标签']: 'कृपया घोषणा टैग चुनें',
	['{{text}}标题']: '{{text}} शीर्षक',
	['{{text}}內文']: '{{text}}内文',
	['{{text}}最多{{inputLimit}}个字']: '{{text}}最多{{inputLimit}} शब्द',
	['公告内文档案大小总计不得大于10MB']: 'सूचना के भीतर दस्तावेज़ फ़ाइल का आकार कुल मिलाकर 10MB से अधिक नहीं होना चाहिए',
	['用户尚未离开，确认要完成对话？']: 'उपयोगकर्ता अभी तक नहीं गया है, क्या आप बातचीत समाप्त करने की पुष्टि करना चाहते हैं?',
	['{{name}} 已于 {{time}} 离开对话']: '{{name}} ने {{time}} पर बातचीत छोड़ दी',
	['客服人员']: 'ग्राहक सेवा प्रतिनिधि',
	['*新增多个IP请使用逗号「 , 」隔开']: '*कई आईपी जोड़ने के लिए कृपया अल्पविराम「 , 」से अलग करें',
	['是否新增IP白名单？']: 'क्या आईपी व्हाइटलिस्ट जोड़ना है?',
	['IP已存在']: 'IP पहले से मौजूद है',
	['监控区管理']: 'निगरानी क्षेत्र प्रबंधन',
	['监控区开关']: 'निगरानी क्षेत्र स्विच',
	['设定监控区开关成功']: 'निगरानी क्षेत्र स्विच सेट करना सफल रहा',
	['启用功能后，等待服务区会增加一个[监控区]页签，显示全平台被AI拦截的对话与未读时间最长的5通对话，点击可快速跳转至相应对话。']: 'सुविधा सक्षम करने के बाद, प्रतीक्षा सेवा क्षेत्र में एक [निगरानी क्षेत्र] टैब जोड़ा जाएगा, जो पूरे प्लेटफॉर्म पर AI द्वारा रोके गए संवाद और सबसे लंबे समय से अपठित 5 संवाद दिखाएगा, जिस पर क्लिक करके आप संबंधित संवाद पर जल्दी जा सकते हैं।',
	['{{name}} 新增了标签 {{tag}}']: '{{name}} ने टैग {{tag}} जोड़ा',
	['{{name}} 移除了标签 {{tag}}']: '{{name}} ने टैग {{tag}} को हटा दिया',
	['状态切换为暂离']: 'स्थिति अस्थायी छोड़ने के लिए स्विच करें',
	['状态切换为工作中']: 'स्थिति कार्यशील में बदल गई',
	['监控区']: 'निगरानी क्षेत्र',
	['自动接线管理']: 'स्वचालित स्विच प्रबंधन',
	['客服全平台接待数量达到上限后，系统不会自动接入等待服务区的对话，客服人员手动接入数量不限制。']: 'ग्राहक सेवा सभी प्लेटफार्मों पर प्राप्तियों की संख्या अधिकतम सीमा पर पहुँचने के बाद, प्रणाली स्वचालित रूप से प्रतीक्षा सेवा क्षेत्र की बातचीत में शामिल नहीं होगी, ग्राहक सेवा कर्मचारियों की मैनुअल फिल्म तक पहुँच की संख्या की कोई सीमा नहीं है।',
	['自动接线数量上限']: 'स्वचालित कनेक्शन की संख्या सीमा',
	['设定自动接线成功']: 'स्वचालित कनेक्शन सेट करना सफल',
	['{{name}} 进线']: '{{name}} कॉल पर',
	['工作/暂离时间']: 'कार्य/अवकाश समय',
	['工作时长报表']: 'कार्यकाल रिपोर्ट',
	['暂离时长报表']: 'अवकाश अवधि रिपोर्ट',
	['平均工作时长']: 'औसत काम करने का समय',
	['平均暂离时长']: 'औसत अस्थायी विदाई अवधि',
	['关键字提醒']: 'कीवर्ड अलर्ट',
	['客户发话']: 'ग्राहक ने बात की',
	['AI发话']: 'एआई की बात',
	['发话来源']: 'बोलने का स्रोत',
	['请输入发话来源、关键字']: 'कृपया स्रोत और कीवर्ड दर्ज करें',
	['新增关键字']: 'नई कुंजी शब्द जोड़ें',
	['修改关键字']: 'संशोधित कुंजीशब्द',
	['新增关键字成功']: 'नया कीवर्ड सफलतापूर्वक जोड़ा गया',
	['修改关键字成功']: 'कीवर्ड सफलतापूर्वक संशोधित किए गए',
	['删除关键字成功']: 'कीवर्ड सफलतापूर्वक हटाया गया',
	['是否删除此关键字？']: 'क्या इस कुंजी शब्द को हटाना है?',
	['请用「；」来分隔不同关键字，关键字不得超过100个字']: 'कृपया विभिन्न कीवर्ड को "；" से विभाजित करें, कीवर्ड 100 शब्दों से अधिक नहीं होने चाहिए।',
	['客户触发关键字 [{{word}}] 请客服人员注意']: 'ग्राहक ने कीवर्ड [{{word}}] को सक्रिय किया कृपया ग्राहक सेवा कर्मियों का ध्यान दें',
	['AI触发关键字 [{{word}}] 请客服人员注意']: 'AI ट्रिगर कुंजीशब्द [{{word}}] कृपया ग्राहक सेवा कार्यालय का ध्यान रखें',
	['请输入通知时间']: 'सूचना का समय दर्ज करें',
	['自动接线开关']: 'स्वचालित स्विच',
	['自动接线数量上限不可为空']: 'स्वचालित कनेक्शन संख्या की अधिकतम सीमा खाली नहीं हो सकती।',
	['请输入数量上限']: 'कृपया संख्या सीमा दर्ज करें',
	['离开状态侦测开关']: 'छोड़ने की स्थिति संवेदन स्विच',
	['开启后当客服人员为平台最后一个工作状态或仍有接待中且无协作给他人对话时，无法切换为离开状态。']: 'खुलने के बाद जब ग्राहक सेवा प्रतिनिधि प्लेटफ़ॉर्म की अंतिम कार्य स्थिति में होते हैं या अभी भी बातचीत में होते हैं और किसी अन्य को संवाद में सहयोग नहीं कर रहे होते हैं, तो वे छोड़ने की स्थिति में नहीं जा सकते।',
	['离开时间通知开关']: 'छोड़ने का समय सूचना स्विच',
	['通知时间不可重复']: 'सूचना समय दोहराया नहीं जा सकता',
	['侦测权限CS帐号离开时间，离开时间达设定时间时通知权限manager以上的帐号，以及触发离开时间的CS帐号本人。']: 'सही अनुमति CS खाता जाने का समय का पता लगाना, जब जाने का समय निर्धारित समय तक पहुँच जाता है, उस समय अनुमति प्रबंधक और ऊपर के खातों को सूचित करें, और जाने के समय को ट्रिगर करने वाले CS खाते को स्वयं सूचित करें।',
	['最后暂离时间报表']: 'अंतिम अस्थायी समय रिपोर्ट',
	['平均最后暂离时间']: 'औसत अंतिम छोड़ने का समय',
	['{{name}} 离开时间已达 [{{minute}}] 分钟 !']: '{{name}} का जाने का समय [{{minute}}] मिनट हो गया है!',
	['历史对话记录下载']: 'इतिहास संवाद रिकॉर्ड डाउनलोड',
	['使用模式']: 'उपयोग का पैटर्न',
	['标准模式']: 'मानक मोड',
	['ID模式']: 'ID मोडेल',
	['即进模式']: 'तत्काल मोड',
	['复制即进网址']: 'कॉपी करके वेबसाइट पर जाएं',
	['生成新网址']: 'नई वेबसाइट बनाना',
	['需提供客户Profile资料的标准模式，此模式为系统预设模式。']: 'ग्राहक प्रोफ़ाइल डेटा के मानक प्रारूप की आवश्यकता है, यह प्रारूप प्रणाली द्वारा पूर्व निर्धारित है।',
	['输入ID 进入客服，可不提供客戶Profile资料。']: 'इनपुट ID ग्राहक सेवा में प्रवेश करें, ग्राहक प्रोफ़ाइल डेटा प्रदान नहीं किया जा सकता है।',
	['透过即进网址可直接进入客服系统，无需提供资料，系统自动给予随机访客名称。']: 'कनेक्ट किए गए लिंक के माध्यम से आप सीधे ग्राहक सेवा प्रणाली में प्रवेश कर सकते हैं, बिना किसी जानकारी के प्रदान किए, प्रणाली स्वतः ही यादृच्छिक आगंतुक नाम देती है।',
	['请再次确认是否從 [<<prevTypeText>>] 切至 [<<nextTypeText>>]']: 'कृपया फिर से पुष्टि करें कि क्या [<<prevTypeText>>] से [<<nextTypeText>>] में स्विच किया गया है।',
	['以下是即进网址']: 'नीचे तत्काल वेबसाइट है',
	['复制网址']: 'कॉपी करें URL',
	['使用模式切换成功']: 'उपयोगकर्ता मोड स्विच सफल',
	['请再次确认是否更换网址 ，一经更换<<redText>>']: 'कृपया एक बार फिर से確認 करें कि क्या网址 बदलें, एक बार बदलने पर<<redText>>',
	['当前即进网址']: 'वर्तमान में प्रवेश करें网址',
	['新即进网址']: 'नया पहुँच वेब पता',
	['复制即进网址成功']: 'कॉपी करके वेबसाइट पर जाना सफल रहा',
	['报表统计']: 'रिपोर्ट सांखेया',
	['操作時間']: 'सञ्चालन समय',
	['统计类型']: 'सांख्यिकी प्रकार',
	['请选择统计类型']: 'कृपया सांख्यिकी प्रकार चुनें',
	['查询参数']: 'क्वेरी पैरामीटर',
	['申请时间']: 'आवेदन समय',
	['产出时间']: 'उत्पादन समय',
	['申请帐号']: 'खाता आवेदन',
	['详细资料']: 'विस्तृत जानकारी',
	['重新执行统计']: 'पुनः सांख्यिकी निष्पादित करें',
	['执行统计']: 'सांख्यिकी करना',
	['登入时间范围']: 'लॉगिन समय सीमा',
	['选择团队：筛选出该团队所有客服人员']: 'टीम का चयन: उस टीम के सभी ग्राहक सेवा कर्मियों को छांटना',
	['API接收日志']: 'API प्राप्त लॉग',
	['新增来源']: 'नया स्रोत',
	['CS']: 'सीएस',
	['包网']: 'पैकेज नेटवर्क',
	['包网API']: 'पैकेज API',
	['第 {{min}} - {{max}} 笔']: '第 {{min}} - {{max}}笔',
	['选择的日期区间需小于等于{{limit}}天']: 'चुनी गई तारीख की सीमा {{limit}} दिन से कम या उसके बराबर होनी चाहिए',
	['请选择日期时间查询条件']: 'कृपया दिनांक और समय खोज मानदंड चुनें',
	['类型']: 'प्रकार',
	['公司']: 'कंपनी',
	['请输入公司']: 'कृपया कंपनी दर्ज करें',
	['会员帐号']: 'सदस्य खाता',
	['请输入会员帐号']: 'कृपया सदस्य खाता दर्ज करें',
	['是否查看详细资料？']: 'क्या आप विवरण देखना चाहते हैं?',
	['传送资料']: 'डेटा भेजें',
	['CS回覆资料']: 'CS उत्तर डेटा',
	['内容']: 'सामग्री',
	['请选择进入的公司']: 'कृपया प्रवेश करने वाली कंपनी का चयन करें',
	['指令数据更新纪录']: 'निर्देशन डेटा अपडेट रिकॉर्ड',
	['1.排序机制：所有公司的指令将统一排序处理，确保系统高效运作。']: '1. क्रमबद्धता तंत्र: सभी कंपनियों के निर्देशों को एकत्रित करके एकीकृत क्रम में संसाधित किया जाएगा, ताकि प्रणाली कुशलता से कार्य करे।',
	['2.数据隔离：用户仅能查看自己公司的更新记录，无法查看其他公司的记录。']: '2. डेटा पृथक्करण: उपयोगकर्ता केवल अपनी कंपनी के अपडेट रिकॉर्ड देख सकते हैं, अन्य कंपनियों के रिकॉर्ड नहीं देख सकते।',
	['微调训练']: 'सूक्ष्म समायोजन प्रशिक्षण',
	['执行微调']: 'माइक्रो-ट्यूनिंग',
	['操作帐号']: 'ऑपरेटिंग खाता',
	['是否修改AI API?']: 'क्या AI API को संशोधित किया गया है?',
	['保存设置']: 'सेटिंग्स सहेजें',
	['修改AI API成功']: 'एआई एपीआई को सफलतापूर्वक संशोधित किया गया',
	['请输入{{text}}']: 'कृपया {{text}} भरें',
	['{{text}}不能超过{{limit}}字元']: '{{text}}不能超过{{limit}}अक्षर',
	['AI API']: 'एआई एपीआई',
	['微调训练记录']: 'सूक्ष्म समायोजन प्रशिक्षण रिकॉर्ड',
	['模型名称']: 'मॉडल का नाम',
	['新增文本']: 'नया पाठ',
	['修改文本']: 'पाठ संशोधित करें',
	['请输入名称']: 'कृपया नाम दर्ज करें',
	['取消修改微调文本']: 'रद्द करें संशोधन सूक्ष्मता पाठ',
	['角色不可为空']: 'पात्र खाली नहीं हो सकता',
	['请选择角色']: 'किरदार चुनें',
	['内容不可为空']: 'सामग्री खाली नहीं हो सकती',
	['请输入内容']: 'कृपया सामग्री दर्ज करें',
	['系统']: 'सिस्टम',
	['会员']: 'सदस्य',
	['AI']: 'एआई',
	['请确认是否取消？']: 'कृपया पुष्टि करें कि क्या आप रद्द करना चाहते हैं?',
	['新增微调文本成功']: 'नई ट्यूनिंग टेक्स्ट सफलतापूर्वक जोड़ा गया',
	['修改微调文本成功']: 'टेक्स्ट को सफलतापूर्वक संशोधित और ट्यून किया गया',
	['自定模型名称']: 'अनुकूलित मॉडल का नाम',
	['微调确认讯息']: 'सूक्ष्म समायोजन पुष्टिकरण संदेश',
	['请确认是否执行微调训练？']: 'कृपया पुष्टि करें कि क्या फाइन-ट्यूनिंग प्रशिक्षण निष्पादित किया जाए?',
	['删除微调文本']: 'माइक्रोडिट टेक्स्ट हटाएँ',
	['请确认是否刪除？']: 'क्या आप हटाने की पुष्टि कर सकते हैं?',
	['刪除微调文本成功']: 'माइक्रो-ट्यूनिंग टेक्स्ट हटा दिया गया',
	['请输入模型名称']: 'कृपया मॉडल का नाम दर्ज करें',
	['执行微调成功']: 'माइक्रो-ट्यूनिंग सफलतापूर्वक हुआ',
	['取消修改文本成功']: 'टेक्स्ट संशोधन रद्द करने में सफलता मिली',
	['取消新增文本成功']: 'नया पाठ जोड़ने में सफलतापूर्वक रद्द किया गया',
	['您已成功登出客服系统。']: 'आप सफलतापूर्वक ग्राहक सेवा प्रणाली से बाहर जा चुके हैं।',
	['如需重新登录，请返回包网！']: 'अगर दोबारा लॉगिन करना है, तो कृपया पैकेज नेटवर्क पर लौटें!',
	['您已成功登出客服系统管理端。']: 'आप सफलतापूर्वक ग्राहक सेवा सिस्टम प्रबंधन से लॉगआउट हो गए हैं।',
	['当「平均等待时间」显示为 0 秒时，可能的原因如下：']: 'जब "औसत प्रतीक्षा समय" 0 सेकंड के रूप में प्रदर्शित होता है, तो संभावित कारण निम्नलिखित हैं:',
	['1.当日所有对话的等待时间均为 0 秒（例如因自动接线或即时应答，无需等待）。']: '1. उस दिन सभी वार्तालापों की प्रतीक्षा समय 0 सेकंड है (जैसे स्वचालित कनेक्शन या तात्कालिक उत्तर, कोई प्रतीक्षा नहीं)।',
	['2.根据公式 「每日总等待时间 ÷ 每日对话数量」，计算结果经四舍五入后为 0 秒。']: '2. सूत्र के अनुसार 「दैनिक कुल प्रतीक्षा समय ÷ दैनिक वार्तालाप संख्या」，गुणनफल को चार_digit_गिनती के बाद 0 सेकंड होगा।',
	['系统显示为 「未登入」 时，表示该帐号在其设定的团队时间内未产生任何对话数据。']: 'सिस्टम "लॉग इन नहीं" के रूप में प्रदर्शित करता है, यह दर्शाता है कि उस खाते ने निर्धारित टीम समय के भीतर कोई बात करने का डेटा उत्पन्न नहीं किया है।',
	['加入微调']: 'माइक्रो-ट्यूनिंग',
	['启用API Key']: 'API कुंजी सक्षम करें',
	['微调汇入对话记录']: 'सूक्ष्म समायोजन वार्तालाप रिकॉर्ड',
	['对话数量']: 'संवाद संख्या',
	['文本最后角色需为AI或客服人员']: 'पाठ के अंत में पात्र AI या ग्राहक सेवा प्रतिनिधि होना चाहिए',
	['汇入微调文本']: 'सूक्ष्म समायोजन पाठ',
	['檔案格式：CSV，且档案大小不得大于']: 'फाइल प्रारूप: CSV, और फ़ाइल का आकार  से बड़ा नहीं होना चाहिए',
	['文本最后角色需为AI或客服人员，请修改后再进行汇出或执行微调']: 'पाठ के अंतिम चर को AI या ग्राहक सेवा प्रतिनिधि होना चाहिए, कृपया इसे संशोधित करें फिर निर्यात करें या उचित समायोजन करें।',
	['批量加入微调']: 'बैच जोड़ें फ़ाइन-ट्यूनिंग',
	['自定加入微调的名称']: 'स्व-निर्धारित समायोजन का नाम',
	['微调名称']: 'सूक्ष्म समायोजन नाम',
	['请输入微调的名称']: 'कृपया माइक्रो-ट्यूनिंग का नाम दर्ज करें',
	['微调的名称']: 'सूक्षम समायोजन का नाम',
	['请确认是否批量删除(共 {{selectedFineTuningRecordsLength}} 笔']: 'कृपया पुष्टि करें कि क्या आप सामूहिक रूप से हटाना चाहते हैं (कुल {{selectedFineTuningRecordsLength}} प्रविष्टियाँ)',
	['已取消']: 'रद्द कर दिया गया',
	['取消微调']: 'रद्द करें समायोजन',
	['取消微调成功']: 'माइक्रो-ट्यूनिंग रद्द करना सफल रहा',
	['取消此笔客服系统微调训练时，需要同时取消对应的 OpenAI 后台微调训练。只有两者均取消后，微调训练才会被完整移除。请确认是否要取消此客服系统微调训练？']: 'इस ग्राहक सेवा प्रणाली के微调 प्रशिक्षण को रद्द करने के लिए, आपको संबंधित OpenAI后台微调 प्रशिक्षण को भी रद्द करना होगा। केवल तभी दोनों रद्द किए जाने के बाद,微调 प्रशिक्षण को पूरी तरह से हटाया जाएगा। कृपया पुष्टि करें कि क्या आप इस ग्राहक सेवा प्रणाली के微调 प्रशिक्षण को रद्द करना चाहते हैं?',
	['复制快捷语成功']: 'कॉपी शॉर्टकट सफल हुआ',
	['复制常用图片成功']: 'कॉमन इमेज सफलतापूर्वक कॉपी की गई',
	['左侧']: 'बाईं ओर',
	['右侧']: 'दाईं ओर',
	['{{text}}正在服务{{total}}则对话']: '{{text}}से सेवा कर रहा है{{total}} संवाद',
	['新增跑马灯成功']: 'नया स्क्रॉलिंग टेक्स्ट सफलतापूर्वक जोड़ा गया',
	['修改跑马灯成功']: 'मार्किंग लाइट सफलतापूर्वक संशोधित किया गया',
	['刪除跑马灯成功']: 'चलती तस्वीर हटा दी गई है',
	['启用跑马灯成功']: 'मारquee सक्रियण सफल',
	['停用跑马灯成功']: 'रनिंग लाइट निलंबित करना सफल',
	['对象栏位']: 'वस्तु क्षेत्र',
	['显示跑马灯内容']: 'मारक पट्टी सामग्री प्रदर्शित करें',
	['请确认是否启用跑马灯？']: 'कृपया पुष्टि करें कि क्या चालू करना है?',
	['请确认是否停用跑马灯？']: 'कृपया पुष्टि करें कि क्या स्क्रॉलिंग टेक्स्ट अक्षम करना है?',
	['请确认是否删除跑马灯？']: 'कृपया पुष्टि करें कि क्या आप चलती文字 हटाना चाहते हैं?',
	['{{text}}最多{{inputLimit}}组']: '{{text}} अधिकतम {{inputLimit}} समूह',
	['数值范围']: 'संख्यात्मक सीमा',
	['数值不能为空']: 'संख्याएँ खाली नहीं हो सकतीं',
	['数值']: 'संख्या',
	['请输入数字']: 'कृपया संख्या दर्ज करें',
	['输入多组文字请用, 区隔']: 'नीचे की सामग्री "हिंदू भाषा" में कैसे कहें?',
	['当用户符合对象设定名称及栏位规则中的内容时，才会生效跑马灯推广']: 'जब उपयोगकर्ता लक्ष्य निर्धारित नाम और श्रेणी नियमों में सामग्री के अनुसार होते हैं, तभी यह चलती रोशनी प्रचार प्रभावी होगी।',
	['新增跑马灯']: 'नया स्क्रोलिंग टेक्स्ट जोड़ें',
	['对象栏位不能为空']: 'वस्तु का क्षेत्र खाली नहीं हो सकता',
	['请输入对象栏位']: 'कृपया वस्तु स्थान भरें',
	['栏位规则']: 'कॉलम नियम',
	['栏位规则不能为空']: 'कालम नियम रिक्त नहीं हो सकते',
	['请选择栏位规则']: 'कृपया कॉलम नियम चुनें',
	['开头图示']: 'प्रारंभिक चित्र',
	['开头图示不能为空']: 'प्रारंभिक चित्र रिक्त नहीं हो सकता है',
	['请选择开头图示']: 'कृपया आरंभ चित्र का चयन करें',
	['跑马灯内容']: 'पार्किंग लाइट सामग्री',
	['修改跑马灯']: 'टेक्स्ट स्क्रोल करना',
	['变更的平台设定将同步套用至下级角色，是否确认修改？']: 'परिवर्तन का प्लेटफ़ॉर्म सेटिंग निचले स्तर के पात्रों पर समान रूप से लागू किया जाएगा, क्या आप संशोधन की पुष्टि करते हैं?',
	['确认要删除[个人/公共]常用图片[{{title}}]吗？']: 'क्या आप [व्यक्तिगत/सार्वजनिक] सामान्य चित्र [{{title}}] को हटाने की पुष्टि करते हैं?',
	['一经确认删除无法复原。']: 'एक बार पुष्टि करने के बाद हटाना पुनर्स्थापित नहीं किया जा सकता।',
	['客服日志']: 'ग्राहक सेवा लॉग',
	['请输入内容等关键字']: 'कृपया सामग्री जैसे कीवर्ड दर्ज करें',
	['确认要删除[个人/公共]快捷语[{{title}}]：[{{content}}]吗？']: 'क्या आप सुनिश्चित हैं कि आप [व्यक्तिगत/सार्वजनिक] शॉर्टकट [{{title}}] को [{{content}}] हटाना चाहते हैं?',
	['没有其他进入标签被开启，故无法关闭此进入标签']: 'कोई अन्य प्रवेश टैग खोला नहीं गया है, इसलिए इस प्रवेश टैग को बंद नहीं किया जा सकता।',
	['没有其他进入标签被开启，故无法删除此标签']: 'कोई अन्य इनपुट टैग खोला नहीं गया है, इसलिए इस टैग को हटाना संभव नहीं है।',
	['所有人']: 'सभी लोग',
	['自定义对象']: 'अनुकूलित वस्तु',
	['套用对象']: 'अनुप्रयोग वस्तु',
	['回主画面']: 'होम स्क्रीन पर वापस जाएं',
	['孟加拉语']: 'বাংলা',
	['繁体中文']: 'परंपरागत चीनी',
	['简体中文']: 'सरल चीनी',
	['韩语']: 'कोरियाई',
	['日语']: 'जापानी',
	['葡萄牙语']: 'पुर्तगाली',
	['印地语']: 'हिन्दी',
	['俄语']: 'रूसी',
	['重要资讯']: 'महत्वपूर्ण जानकारी',
	['在对话中切换语言，在某些情况下，可能导致讯息翻译功能延迟约 10 分钟，影响新旧讯息的读取。确定要切换语言?']: 'संवाद में भाषा बदलने से, sommige मामलों में, संदेश अनुवाद कार्यक्षमता में लगभग 10 मिनट की देरी हो सकती है, जो नए और पुराने संदेशों की पढ़ाई को प्रभावित कर सकती है। क्या आप वास्तव में भाषा बदलना चाहते हैं?',
	['暂无对话']: 'बातचीत नहीं है',
	['档案上传中']: 'फ़ाइल अपलोड हो रही है',
	['{{name}} 已于 {{time}} 开启自动推播']: '{{name}} ने {{time}} पर स्वचालित पुश चालू किया',
	['{{name}} 已于 {{time}} 关闭自动推播']: '{{name}} ने {{time}} पर स्वचालित पुश बंद किया',
	['商户代码']: 'मर्चेंट कोड',
	['请输入商户代码']: 'कृपया मर्चेंट कोड दर्ज करें',
	['密钥']: 'सीक्रेट की',
	['请输入密钥']: 'कृपया सीक्रेट की दर्ज करें',
	['共同设定']: 'सामान्य सेटिंग',
	['充值未到帐设定']: 'रिचार्ज न पहुंचे सेटिंग',
	['出款未到帐设定']: 'निकासी न पहुंचे सेटिंग',
	['确认进行储存？']: 'क्या आप सहेजना चाहते हैं?',
	['SKILL开关']: 'SKILL स्विच',
	['请输入SKILL']: 'SKILL दर्ज करें',
	['派单 API 参数']: 'ऑर्डर डिस्पैच API पैरामीटर',
	['请输入派单API URL']: 'ऑर्डर डिस्पैच API URL दर्ज करें',
	['开单者username']: 'ऑर्डर निर्माता उपयोगकर्ता नाम',
	['请输入开单者username']: 'ऑर्डर निर्माता उपयोगकर्ता नाम दर्ज करें',
	['频道名称']: 'चैनल का नाम',
	['请输入频道名称']: 'चैनल का नाम दर्ज करें',
	['开单原因']: 'ऑर्डर का कारण',
	['请输入开单原因']: 'ऑर्डर का कारण दर्ज करें',
	['充值订单查询 API URL']: 'रिचार्ज ऑर्डर क्वेरी API URL',
	['出款订单查询 API URL']: 'निकासी ऑर्डर क्वेरी API URL',
	['同义词设定']: 'समानार्थी शब्द सेटिंग',
	['开启BM25']: 'BM25 चालू करें',
	['同义词']: 'पर्यायवाची',
	['更新时间']: 'अपडेट समय',
	['批次新增同义词']: 'समूह में समानार्थक शब्द जोड़ें',
	['修改同义词']: 'सुधारें समानार्थी शब्द',
	['新增同义词']: 'नया समानार्थक जोड़ें',
	['请输入同义词，使用逗号区隔不同词汇']: 'कृपया पर्यायवाची शब्द दर्ज करें, भिन्न शब्दावली को अल्पविराम से अलग करें',
	['请以逗号区隔不同词汇，用分号区隔不同组同义词']: 'नीचे, सामग्री, "हिन्दी", में, कैसे, कहा, जाएगा?',
	['输入格式说明：']: 'इनपुट फ़ॉर्मेट विवरण:',
	['请用，区隔不同词汇，例如：充值,储值,入金,课金']: 'कृपया अलग शब्दों को अलग करने के लिए, उदाहरण के लिए: रिचार्ज, जमा, पैसे डालना, शुल्क देना',
	['词汇与标点符号前后不要出现空白']: 'शब्दावली और विराम चिह्नों के चारों ओर कोई खाली स्थान नहीं होना चाहिए',
	['请用；或分行(enter)区隔同组同义词，例如：']: 'कृपया एक दूसरे के समानार्थक शब्दों को ";" या पंक्तियों (enter) द्वारा अलग करें, उदाहरण के लिए:',
	['充值,储值,入金,课金']: 'रिचार्ज',
	['log in,登入;亲,宝贝']: 'लॉग इन,लॉग इन; प्रिय,बच्चा',
	['请输入同义词']: '同ार्थक शब्द दर्ज करें',
	['同义词不可为空']: 'समार्थक शब्द खाली नहीं हो सकते',
	['同义词格式有误']: 'समानार्थक शब्द प्रारूप गलत है',
	['同义词不可有特殊字元']: 'समानार्थी शब्दों में विशेष वर्ण नहीं होने चाहिए',
	['字元不可超过10000']: 'अक्षर 10000 से अधिक नहीं हो सकते',
	['需至少输入两个词汇']: 'कम से कम दो शब्दों का इनपुट होना चाहिए',
	['删除同义词']: '同ार्थक शब्द हटाएँ',
	['请确认是否删除同义词？']: 'कृपया पुष्टि करें कि क्या समानार्थक शब्द हटाना है?',
	['新增同义词成功']: 'नया पर्याय सफलतापूर्वक जोड़ा गया',
	['新增同义词失败']: 'समानार्थी शब्द जोड़ने में विफल',
	['修改同义词成功']: 'संशोधन समानार्थक सफल',
	['修改同义词失败']: 'सुधार समानार्थी शब्द विफल',
	['删除同义词成功']: 'समानार्थी शब्द सफलतापूर्वक हटाए गए',
	['删除同义词失败']: '同ार्थक शब्द हटाना असफल रहा',
	['内容有重复字']: 'सामग्री में दोहराए हुए शब्द हैं',
	['新增图片，详细图片请参考公告管理']: 'नई छवि जोड़ें, विस्तृत छवि के लिए कृपया公告 प्रबंधन देखें',
	['目前只支援ChatGPT进行微调训练']: 'वर्तमान में केवल ChatGPT को फाइन-ट्यून प्रशिक्षित करने का समर्थन है।',
	['AI系列']: 'एआई सीरीज़',
	['AI系列不能为空']: 'एआई सीरीज़ खाली नहीं हो सकती',
	['启用ChatGPT']: 'ChatGPT सक्षम करें',
	['启用Gemini']: 'जेमिनी सक्षम करें',
	['AI客服']: 'एआई ग्राहक सेवा',
	['ID入口']: 'ID प्रवेश',
	['IP']: 'आईपी',
	['USER ID']: 'उपयोगकर्ता आईडी',
	['{{itemLabel}}內容不可为空']: '{{itemLabel}} सामग्री खाली नहीं हो सकती',
	['{{text}}仅能输入数字']: '{{text}} केवल संख्याएँ दर्ज कर सकता है',
	['{{text}}最多{{limit}}个字元']: '{{text}} में अधिकतम {{limit}} वर्ण',
	['{{text}}最多數字{{limit}}碼']: '{{text}}अधिकतम संख्या{{limit}}अंक',
	['{{time}}分']: '{{time}} मिनट',
	['{{time}}时']: '{{time}} बजे',
	['{{time}}秒']: '{{time}} सेकंड',
	['上一则发送后等待时间']: 'पिछले संदेश को भेजने के बाद प्रतीक्षा समय',
	['上传图片']: 'इमेज अपलोड करें',
	['主要API keys']: 'मुख्य एपीआई कुंजी',
	['主要语言']: 'मुख्य भाषा',
	['事件']: 'घटना',
	['以查看预览效果']: 'पूर्वावलोकन प्रभाव देखने के लिए',
	['依照选择模组设定UI显示位置及功能。']: 'चयनित मॉड्यूल के अनुसार UI प्रदर्शन स्थिति और कार्य सेट करें।',
	['依照选择的风格进行调整配色（含背景、框体、配色、线条感）。']: 'शैली के अनुसार रंग समायोजित करें (पृष्ठभूमि, ढांचे, रंग, रेखाओं का अनुभव शामिल)।',
	['修改帐号履历成功']: 'खाता इतिहास सफलतापूर्वक संशोधित किया गया',
	['修改翻译API成功']: 'अनुवादAPI में संशोधन सफल',
	['充值帐号']: 'रिचार्ज खाता',
	['共 {{numOfItems}} 笔']: 'कुल {{numOfItems}} आइटम',
	['关 闭']: 'बंद',
	['关闭后，整个推播系统将停止运作，所有推播讯息会暂时无效。您随时可以重新开启。']: 'बंद करने के बाद, पूरा पुश सिस्टम काम करना बंद कर देगा, सभी पुश संदेश अस्थायी रूप से निष्क्रिय हो जाएंगे। आप कभी भी इसे फिर से खोल सकते हैं।',
	['内容最多20字元']: 'सामग्री अधिकतम 20 वर्ण',
	['内容预览']: 'सामग्री पूर्वावलोकन',
	['切换后，跑马灯文字与快捷键可能会出现显示不清晰或对比度不足的情况，需到后台进行重新设定']: 'स्विच करने के बाद, स्क्रोलिंग टेक्स्ट और शॉर्टकट कुंजियाँ अस्पष्ट या विपरीतता में कमी दिखा सकते हैं, जिन्हें बैकएंड में फिर से सेट करने की आवश्यकता है।',
	['删除履历']: 'रिज़्यूमे हटाएँ',
	['删除帐号履历成功']: 'खाता इतिहास हटाना सफल रहा',
	['删除跑马灯']: 'बुलबुले को हटाएँ',
	['加载中...']: 'लोड हो रहा है...',
	['勾选后，该账号在联系客服时，账号名称旁会显示']: 'चेक करने के बाद, उस खाते का नाम ग्राहक सेवा से संपर्क करते समय प्रदर्शित होगा।',
	['即时预览']: 'तत्काल पूर्वावलोकन',
	['取消新增微调文本']: 'नए सूक्ष्म समायोजन पाठ को रद्द करें',
	['古典深色风格']: 'शास्त्रीय गहरे रंग की शैली',
	['單次']: 'एक बार',
	['回传表单']: 'फॉर्म वापस करें',
	['外观风格']: 'बाहरी शैली',
	['客户端视觉设定']: 'क्लाइंट दृश्य सेटिंग',
	['客户端视觉设定成功']: 'ग्राहक दृश्य सेटिंग सफलतापूर्वक',
	['尚无资料']: 'अभी तक कोई जानकारी नहीं है',
	['展开']: 'खोलना',
	['履历数量']: 'रिज़ुमे की संख्या',
	['帐号履历']: 'खाता इतिहास',
	['帐号履历管理']: 'खाता इतिहास प्रबंधन',
	['平台代码不能有空白']: 'प्लेटफ़ॉर्म कोड में खाली स्थान नहीं हो सकते।',
	['平台代码仅能输入英文和数字']: 'प्लेटफॉर्म कोड में केवल अंग्रेजी और संख्या दर्ज की जा सकती है',
	['平台代码最多5码']: 'प्लेटफ़ॉर्म कोड अधिकतम 5 अंक',
	['平台代码最少2码']: 'प्लेटफ़ॉर्म कोड कम से कम 2 अंक होना चाहिए',
	['平台语言']: 'प्लेटफ़ॉर्म भाषा',
	['平均首次工作时间']: 'औसत पहली नौकरी का समय',
	['建立者']: 'स्रष्टा',
	['开关']: 'स्विच',
	['快速通道']: 'तेज़ रास्ता',
	['手动推播']: 'हाथ से पुश',
	['手机版']: 'मोबाइल संस्करण',
	['批量删除']: 'बातचीत हटाना',
	['排序']: 'क्रम',
	['推播功能']: 'पुश सुविधा',
	['推播功能 OFF：推播功能关闭整个系统不运作，列表中的所有策略都无效。']: 'पुश सूचना सुविधा बंद: पुश सूचना सुविधा समग्र प्रणाली को निष्क्रिय कर देती है, सूची में सभी रणनीतियाँ अमान्य हो जाती हैं।',
	['推播时间']: 'पुश समय',
	['推播讯息列表']: 'पुश अधिसूचना सूची',
	['推播设定']: 'पुश सेटिंग्स',
	['操作内容']: 'कार्य सामग्री',
	['收起']: 'छोड़ना',
	['数值/内容']: 'संख्या/सामग्री',
	['数值/内容不可为空']: 'संख्यात्मक/सामग्री खाली नहीं हो सकती',
	['数值只能输入数字、负号、小数点']: 'संख्याएँ केवल संख्या, ऋण चिह्न, दशमलव बिंदु ही प्रविष्ट की जा सकती हैं',
	['数值小数最多6位数']: 'संख्यात्मक दशमलव अधिकतम 6 अंकों का',
	['数值整数最多15位']: 'संख्यात्मक पूर्णांक अधिकतम 15 अंकों का',
	['新增履历']: 'नया रिज़्यूमे',
	['新增帐号履历成功']: 'नया खाता विवरण सफलतापूर्वक जोड़ा गया',
	['新增类型']: 'नई श्रेणी',
	['无工作']: 'बेरोजगारी',
	['时间设定需至少为 3 分钟']: 'समय सेटिंग कम से कम 3 मिनट होनी चाहिए',
	['是否修改翻译API?']: 'क्या अनुवाद API में संशोधन किया गया है?',
	['更新成功']: 'सफलता से अपडेट',
	['更新者']: 'अपडेटर',
	['架构模组']: 'संरचना मॉड्यूल',
	['栏位名称']: 'स्तंभ का नाम',
	['栏位类型']: 'कॉलम प्रकार',
	['栏位类型不可为空']: 'कॉलम प्रकार खाली नहीं हो सकता',
	['档案格式不符']: 'फाइल प्रारूप असंगत है',
	['PDF文件']: 'PDF दस्तावेज़',
	['模式与间隔时间']: 'मोड और अंतराल समय',
	['欢迎回来']: 'स्वागत है वापसी',
	['此操作将自动翻译其他语言，原有输入内容将被翻译结果覆盖，请确认是否继续？']: 'इस क्रिया से अन्य भाषाओं का स्वतः अनुवाद किया जाएगा, मौजूदा इनपुट सामग्री को अनुवादित परिणाम द्वारा अधिलेखित किया जाएगा, कृपया पुष्टि करें कि क्या आप जारी रखना चाहते हैं?',
	['汇入']: 'आयात',
	['汇入微调文本成功']: 'माइक्रो-ट्यूनिंग टेक्स्ट सफलतापूर्वक आयात किया गया',
	['汇出微调文本成功']: 'एक्सपोर्ट माइक्रो-ट्यूनिंग टेक्स्ट सफलतापूर्वक',
	['清空翻译']: 'साफ़ करना',
	['所有语系内容皆填写完成后才可确定，可使用自动翻译补齐其余语系']: 'पुष्टि करने से पहले सभी भाषाओं की सामग्री पूरी होनी चाहिए। शेष भाषाओं को भरने के लिए स्वचालित अनुवाद का उपयोग कर सकते हैं।',
	['标题与内容皆需填写才可自动翻译']: 'स्वचालित अनुवाद से पहले शीर्षक और सामग्री दोनों भरना आवश्यक है।',
	['状态持续时间']: 'स्थिति की अवधि',
	['用户帐号']: 'उपयोगकर्ता खाता',
	['用户帐号不能为空']: 'उपयुक्त खाता नाम खाली नहीं हो सकता',
	['电脑版']: 'डेस्कटॉप संस्करण',
	['目前无适用推播']: 'वर्तमान में कोई लागू पुश नहीं है',
	['目前有启用中的侦测语言平台，无法关闭']: 'वर्तमान में एक सक्रिय निगरानी भाषा मंच है, जिसे बंद नहीं किया जा सकता।',
	['确定删除IP白名单？']: 'क्या आप आईपी श्वेतसूची हटाने की पुष्टि करते हैं?',
	['确定发送推播？']: 'क्या धक्का भेजना सुनिश्चित है?',
	['确定要关闭推播功能吗？']: 'क्या आप पुश नोटिफिकेशन बंद करना चाहते हैं?',
	['确认删除此笔履历?']: 'क्या आप इस प्रविष्टि को हटाना सुनिश्चित करते हैं?',
	['确认要删除推播讯息？']: 'क्या आप सच में पुश संदेश हटाना चाहते हैं?',
	['立即登入']: 'तुरंत लॉगिन करें',
	['第 {{min}} - {{max}} 笔/共 {{numOfItems}} 笔']: 'गत {{min}} - {{max}} आयोग/कुल {{numOfItems}} आयोग',
	['筛选条件']: 'फ़िल्टर मानदंड',
	['类型名称']: 'प्रकार नाम',
	['系统预设模组']: 'सिस्टम पूर्वनिर्धारित मॉड्यूल',
	['经典浅色风格']: 'क्लासिक हल्का शैली',
	['翻译API']: 'अनुवाद एपीआई',
	['聊天介面']: 'चेट इंटरफेस',
	['自动推播']: 'स्वचालित पुश',
	['自动推播功能']: 'स्वचालित पुश नोटिफिकेशन सुविधा',
	['自动推播功能 OFF：列表中的所有推播讯息虽然仍可被客服手动执行，但所有计时器功能停止运作。']: 'स्वचालित पुश फीचर बंद: सूची में सभी पुश संदेशों को ग्राहक सेवा द्वारा मैनुअल रूप से क्रियान्वित किया जा सकता है, लेकिन सभी टाइमर फ़ीचर्स काम करना बंद कर देते हैं।',
	['自定义']: 'कस्टमाइज़',
	['自定义文案']: 'कस्टम टेक्स्ट',
	['自客服接起对话后开始计算']: 'ग्राहक सेवा द्वारा वार्ता लेने के बाद गणना शुरू करें',
	['该类型目前有推播讯息套用中，无法删除']: 'इस प्रकार का वर्तमान में पुश सूचना एप्लिकेशन में लागू है, इसे हटाया नहीं जा सकता।',
	['详细说明']: 'विस्तृत विवरण',
	['请先选择推播类型']: 'कृपया पहले पुश सूचना प्रकार चुनें',
	['请确认是否批量删除(共 {{selectedFineTuningRecordsLength}} 笔)？']: 'कृपया पुष्टि करें कि क्या आप सामूहिक रूप से हटाना चाहते हैं (कुल {{selectedFineTuningRecordsLength}} रिकॉर्ड)？',
	['请输入事件']: 'कृपया घटना दर्ज करें',
	['请输入会员ID']: 'कृपया सदस्य आईडी दर्ज करें',
	['请输入內容']: 'कृपया सामग्री दर्ज करें',
	['请输入关键字']: 'कीवर्ड दर्ज करें',
	['请输入您的会员 ID 以继续']: 'कृपया आगे बढ़ने के लिए अपना सदस्य ID दर्ज करें',
	['请输入数值/内容']: 'कृपया संख्या/सामग्री दर्ज करें',
	['请输入文字']: 'कृपया पाठ दर्ज करें',
	['请输入栏位名称']: 'कृपया स्तंभ का नाम दर्ज करें',
	['请输入用户帐号']: 'कृपया उपयोगकर्ता खाता दर्ज करें',
	['请输入类型名称']: 'प्रकार का नाम दर्ज करें',
	['请输入详细说明']: 'कृपया विस्तृत विवरण दर्ज करें',
	['请选择上方下拉选单']: 'कृपया उपरोक्त ड्रॉप-डाउन मेनू का चयन करें',
	['请选择主要语言自动翻译']: 'कृपया मुख्य भाषा का स्वचालित अनुवाद चुनें',
	['请选择帐号状态']: 'कृपया खाता स्थिति चुनें',
	['请选择平台']: 'कृपया प्लेटफार्म चुनें',
	['请选择推播项目']: 'कृपया पुश नोटिफिकेशन आइटम चुनें',
	['请选择栏位类型']: 'कृपया कॉलम प्रकार चुनें',
	['请选择类型']: 'कृपया प्रकार चुनें',
	['请选择类型与项目(标题)以预览内容']: 'कृपया सामग्री पूर्वावलोकन के लिए प्रकार और आइटम (शीर्षक) का चयन करें।',
	['请选择表单选项']: 'कृपया फ़ॉर्म विकल्प चुनें',
	['请选择运算规则']: 'कृपया गणनाएँ चुनें',
	['请选择预览画面']: 'कृपया पूर्वावलोकन चित्र चुनें',
	['跑马灯设定']: 'पारंपरिक चिह्न सेटिंग',
	['轮播']: 'कैरousel',
	['轮播模式']: 'घूर्णन मोड',
	['轮播间隔时间']: 'रोटेटिंग अंतराल समय',
	['运算规则']: 'गणना नियम',
	['运算规则不可为空']: 'संचालन नियम रिक्त नहीं हो सकते',
	['返回上一层']: 'पिछली परत पर वापस जाएं',
	['返回上一页']: 'पिछले पृष्ठ पर जाएँ',
	['送出推播']: 'प्रयोजन भेजें',
	['选单介面']: 'चयन इंटरफ़ेस',
	['选择推播类型']: 'पुश प्रकार चुनें',
	['选择推播项目(标题)']: 'पुश नोटिफिकेशन आइटम (शीर्षक)',
	['通知时间']: 'सूचना समय',
	['通知时间不能为空']: 'सूचना का समय खाली नहीं हो सकता',
	['重新产生Key/IV']: 'की/आईवी को फिर से उत्पन्न करें',
	['重要客户']: 'महत्वपूर्ण ग्राहक',
	['需为1~60正整数']: '1 से 60 के सकारात्मक पूरे संख्या चाहिए',
	['预估时间']: 'अनुमानित समय',
	['预览图片']: 'छवि पूर्वावलोकन',
	['首次工作时间报表']: 'पहली बार काम समय रिपोर्ट',
	['日志管理']: 'लॉग प्रबंधन',
	['API传送日志']: 'API ट्रांसमिशन लॉग',
	['订单号']: 'ऑर्डर नंबर',
	['三方单号']: 'तृतीय-पक्ष ऑर्डर नंबर',
	['请输入订单号']: 'कृपया ऑर्डर नंबर दर्ज करें',
	['请输入三方单号']: 'कृपया तृतीय-पक्ष ऑर्डर नंबर दर्ज करें',
	['充值订单查询']: 'रिचार्ज ऑर्डर खोज',
	['出款订单查询']: 'निकासी ऑर्डर खोज',
	['开派单']: 'डिस्पैच ऑर्डर बनाएं',
	['传送派单信息']: 'डिस्पैच जानकारी भेजें',
	['CS传送资料']: 'CS द्वारा भेजा गया डेटा',
	['平台回覆资料']: 'प्लेटफ़ॉर्म उत्तर डेटा',
	['{{text}}需以{{prefix}}开头']: '{{-text}} {{-prefix}} से शुरू होना चाहिए',
	['系统通知']: 'सिस्टम सूचना',
	['派单传送讯息']: 'डिस्पैच संदेश भेजें',
	['派单传送档案']: 'डिस्पैच फ़ाइल भेजें',
	['请输入平台']: 'कृपया प्लेटफ़ॉर्म दर्ज करें',
	['派单讯息润饰设定']: 'डिस्पैच संदेश परिष्करण सेटिंग',
	['此指令不会载入「AI共同设定」与「平台AI设定」，为独立的 Agent 使用']: 'यह निर्देश "एआई सह-निर्धारण" और "प्लेटफॉर्म एआई सेटिंग" लोड नहीं करता; एक स्वतंत्र Agent के रूप में उपयोग किया जाता है',
	['用户个人设定']: 'उपयोगकर्ता व्यक्तिगत सेटिंग',
	['新增用户个人资讯']: 'उपयोगकर्ता व्यक्तिगत जानकारी जोड़ें',
	['个人资讯参数名称']: 'व्यक्तिगत जानकारी पैरामीटर नाम',
	['请输入个人资讯参数名称']: 'कृपया व्यक्तिगत जानकारी पैरामीटर नाम दर्ज करें',
	['*新增多个请使用逗号「 , 」隔开']: '*एकाधिक जोड़ने के लिए कृपया अल्पविराम「 , 」से अलग करें',
	['用来设定该平台哪些个人资讯要丢给AI，只有设定在「用户个人设定」的参数，才会传送给AI']: 'इस प्लेटफ़ॉर्म की कौन-सी व्यक्तिगत जानकारी AI को भेजी जाए, यह सेट करने के लिए उपयोग किया जाता है। केवल "उपयोगकर्ता व्यक्तिगत सेटिंग" में सेट किए गए पैरामीटर ही AI को भेजे जाएंगे',
	['批次删除用户个人资讯']: 'उपयोगकर्ता व्यक्तिगत जानकारी बैच हटाना',
	['确定要批次删除用户个人资讯吗？']: 'क्या आप वाकई उपयोगकर्ता व्यक्तिगत जानकारी को बैच में हटाना चाहते हैं?',
	['个人资讯参数名称不能为空']: 'व्यक्तिगत जानकारी पैरामीटर नाम खाली नहीं हो सकता',
	['已存在「{{name}}」']: '「{{-name}}」पहले से मौजूद है',
	['最多可新增{{limit}}个，已超过上限']: 'अधिकतम {{-limit}} जोड़ सकते हैं, सीमा पार हो गई है',
	['新增用户个人资讯成功']: 'उपयोगकर्ता व्यक्तिगत जानकारी सफलतापूर्वक जोड़ी गई',
	['新增用户个人资讯失败']: 'उपयोगकर्ता व्यक्तिगत जानकारी जोड़ने में विफल',
	['删除用户个人资讯成功']: 'उपयोगकर्ता व्यक्तिगत जानकारी सफलतापूर्वक हटाई गई',
	['删除用户个人资讯失败']: 'उपयोगकर्ता व्यक्तिगत जानकारी हटाने में विफल',
	['图像管理']: 'छवि प्रबंधन',
	['自定义图像']: 'कस्टम छवि',
	['档案格式：“PNG、JPG”档案大小不得大于 500KB']: 'फ़ाइल प्रारूप: "PNG, JPG", फ़ाइल का आकार 500KB से अधिक नहीं होना चाहिए',
	['档案最大500K']: 'फ़ाइल अधिकतम 500K',
	['新增图像成功']: 'छवि सफलतापूर्वक जोड़ी गई',
	['删除图像成功']: 'छवि सफलतापूर्वक हटाई गई',
	['是否确定删除图像？']: 'क्या आप वाकई इस छवि को हटाना चाहते हैं?',
	['内容设定']: 'सामग्री सेटिंग',
	['英语']: 'अंग्रेज़ी',
	['{{language}}内容']: '{{language}} सामग्री',
	['请输入{{language}}内容']: 'कृपया {{language}} सामग्री दर्ज करें',
	['请选择时间']: 'कृपया समय चुनें',
	['请选择公司']: 'कृपया कंपनी चुनें',
	['请输入{{label}}']: 'कृपया {{label}} दर्ज करें',
	['原文参考（{{language}}）']: 'मूल पाठ संदर्भ ({{language}})',
	['确定清空设定吗？']: 'क्या आप वाकई सेटिंग्स साफ़ करना चाहते हैं?',
	['确定取消设定吗？']: 'क्या आप वाकई सेटिंग्स रद्द करना चाहते हैं?',
	['{{language}}{{tab}}']: '{{language}} {{tab}}',
	['未完成']: 'अपूर्ण',
	['{{language}}{{label}}超过{{limit}}字']: '{{language}} {{label}} {{limit}} वर्णों से अधिक है',
	['公告标题']: 'घोषणा शीर्षक',
	['进线IP']: 'इनकमिंग IP',
	['请输入进线IP']: 'इनकमिंग IP दर्ज करें',
	['模型切换：{{fromModel}} -> {{toModel}}']: 'मॉडल स्विच: {{fromModel}} -> {{toModel}}',
	['包网后台删除帐号后，客服系统帐号将同步删除']: 'BW बैकएंड में खाता हटाने के बाद, ग्राहक सेवा प्रणाली का खाता समकालिक रूप से हटा दिया जाएगा',
	['系统已有新版本，请重新整理']: 'नया संस्करण उपलब्ध है, कृपया पुनः लोड करें',
	['页面加载失败，请重试']: 'पेज लोड नहीं हो सका, कृपया पुनः प्रयास करें',
	['翻译中']: 'अनुवाद हो रहा है',
	['监控与即时摘要设定']: 'निगरानी और तत्काल सारांश सेटिंग',
	['批量转接']: 'बैच ट्रांसफर',
	['已选 {{count}} 则对话']: '{{count}} वार्तालाप चुने गए',
	['勾选']: 'चयन',
	['全平台服务人数']: 'सभी प्लेटफ़ॉर्म सेवा संख्या',
	['未开启{{platform}}平台']: '{{-platform}} प्लेटफ़ॉर्म सक्षम नहीं है',
	['成功由 {{inviter}} 转接至 {{invitee}}，共 {{count}} 则']: '{{-inviter}} से {{-invitee}} में सफलतापूर्वक स्थानांतरित, कुल {{count}}।',
	['接受']: 'स्वीकार करें',
	['拒绝({{seconds}}S)']: 'अस्वीकार करें({{seconds}}S)',
	['生成链接']: 'लिंक जनरेट करें',
	['链接生成中...']: 'लिंक जनरेट हो रहा है...',
	['复制链接']: 'लिंक कॉपी करें',
	['已复制链接']: 'लिंक कॉपी हो गया',
	['档案上传失败']: 'फ़ाइल अपलोड विफल',
	['转档失败，请重新上传']: 'रूपांतरण विफल, कृपया दोबारा अपलोड करें',
	['人工回复']: 'मैनुअल जवाब',
	['检视回复']: 'जवाब देखें',
	['{{time}} AI 拦截对话']: '{{time}} AI ने बातचीत रोकी',
	['AI 拦截原因与人工回复']: 'AI रोक का कारण और मैनुअल जवाब',
	['人工回复失败']: 'मैनुअल जवाब विफल',
	['回复讯息']: 'जवाब संदेश',
	['对话摘要']: 'बातचीत का सारांश',
	['建议回复']: 'सुझाया गया जवाब',
	['拦截原因']: 'रोक का कारण',
	['拦截回复']: 'रोका गया जवाब',
	['确定送出']: 'पुष्टि करें और भेजें',
	['生成链接失败']: 'लिंक जनरेट करने में विफल',
	['连接超时，请稍后再试']: 'कनेक्शन का समय समाप्त हो गया, कृपया बाद में पुनः प्रयास करें',
	['上一则']: 'पिछला',
	['下一则']: 'अगला',
	['重新传送']: 'पुनः भेजें',
	['传送中...']: 'भेजा जा रहा है...',
	['用户端翻译失败']: 'उपयोगकर्ता के लिए अनुवाद विफल',
	['重新传送失败']: 'पुनः भेजना विफल',
	['请确认是否删除以下模型？']: 'क्या आप निम्नलिखित मॉडल को हटाना चाहते हैं?',
	['新增模型']: 'मॉडल जोड़ें',
	['请选择AI系列']: 'कृपया AI शृंखला चुनें',
	['支援模型']: 'समर्थित मॉडल',
	['支援模型不能为空']: 'समर्थित मॉडल खाली नहीं हो सकता',
	['请选择支援模型']: 'कृपया समर्थित मॉडल चुनें',
	['AI模型管理']: 'AI मॉडल प्रबंधन',
	['模型不能为空']: 'मॉडल खाली नहीं हो सकता',
	['请选择模型']: 'कृपया मॉडल चुनें',

	['对话类型']: 'संवाद प्रकार',
	['单纯AI讯息']: 'केवल एआई संदेश',
	['单纯人员讯息']: 'केवल कर्मचारी संदेश',
	['人员+AI讯息']: 'कर्मचारी + एआई संदेश',
	['是否经过AI拦截']: 'क्या एआई द्वारा अवरोधित किया गया?',
	['是否修改AI拦截建议回覆']: 'क्या एआई सुझाया गया उत्तर संशोधित किया गया?',
	['监控API keys']: 'निगरानी एपीआई कुंजी',
	['管理']: 'प्रबंधन',

	['启用显性快取']: 'स्पष्ट कैश सक्षम करें',
	['AI监控拦截总量']: 'एआई निगरानी अवरोधन कुल',
	['AI监控拦截']: 'एआई निगरानी अवरोधन',
	['有修改建议回覆总量']: 'संशोधित सुझाए गए उत्तर सहित',
	['触发关键字：{{keywords}}。']: 'ट्रिगर किए गए कीवर्ड: {{-keywords}}।',

	['版面已套用，但尚未同步至帐号']: 'लेआउट लागू हो गया, लेकिन अभी तक खाते में सिंक नहीं हुआ',
	['服务器重设失败，下次开启工作区时会再同步']: 'सर्वर पर रीसेट विफल रहा, अगली बार वर्कस्पेस खोलने पर फिर सिंक होगा',
	['浏览器无法储存版面，离开前请确认帐号同步完成']: 'ब्राउज़र लेआउट सहेज नहीं सकता, जाने से पहले खाते में सिंक पूरा होना सुनिश्चित करें',

	['重设版面配置']: 'लेआउट रीसेट करें',
	['确定要将版面配置回复为系统预设吗？']: 'क्या लेआउट को सिस्टम डिफ़ॉल्ट पर वापस लाना है?',
	['客服支援语言']: 'ग्राहक सेवा समर्थित भाषाएँ',
	['请选择支援语言']: 'कृपया समर्थित भाषाएँ चुनें',
	['请选择客服支援语言']: 'कृपया ग्राहक सेवा समर्थित भाषाएँ चुनें',

	['删除平台']: 'प्लेटफ़ॉर्म हटाएं',
	['是否确定删除{{code}}平台']: 'क्या आप वाकई {{-code}} प्लेटफ़ॉर्म को हटाना चाहते हैं?',
	['删除{{code}}平台成功']: '{{-code}} प्लेटफ़ॉर्म सफलतापूर्वक हटाया गया',
	['上传图片或PDF']: 'इमेज या PDF अपलोड करें',
	['当前平台维护中，如有疑问请联系管理员']: 'वर्तमान प्लेटफ़ॉर्म रखरखाव में है। किसी भी प्रश्न के लिए प्रशासक से संपर्क करें।',
	['当前平台已禁用，如有疑问请联系管理员']: 'वर्तमान प्लेटफ़ॉर्म अक्षम कर दिया गया है। किसी भी प्रश्न के लिए प्रशासक से संपर्क करें।',
	['收回提示文字']: 'वापस लेने का संकेत पाठ',
	['请输入提示文字，例如：抱歉亲 妹子发错了更正一下哦！']: 'कृपया प्रॉम्प्ट दर्ज करें, जैसे: क्षमा करें! गलती से भेज दिया मैं इसे सुधार रहा हूँ!',
	['标签名称']: 'लेबल नाम',
	['预览失败']: 'पूर्वावलोकन विफल',
	['放大']: 'ज़ूम इन',
	['缩小']: 'ज़ूम आउट',
	['上一页']: 'पिछला पृष्ठ',
	['下一页']: 'अगला पृष्ठ',
	['点击预览']: 'पूर्वावलोकन के लिए क्लिक करें',
};
